/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-lonely-if */
/* eslint-disable radix */
/* eslint-disable react/no-array-index-key */
/* eslint-disable arrow-body-style */
import {
  Stack,
  TextField,
  Button,
  Container,
  Typography,
  Paper,
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TablePagination,
  LinearProgress,
  FormControl,
  Autocomplete,
  Collapse,
  Snackbar,
  Alert,
  RadioGroup,
  FormControlLabel,
  Radio,
  Grid,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  IconButton,
  InputLabel,
  Select,
  MenuItem,
  Box,
  Checkbox, 
  ListItemText
} from '@mui/material';
import { Label } from 'reactstrap';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import LockResetIcon from '@mui/icons-material/LockReset';
import DownloadIcon from '@mui/icons-material/Download';
import CloseIcon from '@mui/icons-material/Close';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import 'jspdf-autotable';
import './UserPrivilegesReports.css';
import moment from 'moment';
import XLSXS from 'xlsx-js-style';
import RemoveIcon from '@mui/icons-material/Remove';

import { useLocation, useNavigate } from 'react-router-dom';
import axios from '../axiosConfig';
import NoimageFound from '../media/noimage.jpg';
import { ReactComponent as MastersIcon } from '../media/filter.svg';



// table header cell styles
const StyledTableCell = styled(TableCell)({
  color: 'white',
  fontWeight: '800',
  // textAlign: 'center',
  backgroundColor: '#219C90',
  padding: 'none',
  whiteSpace: 'nowrap',
});

const useStyles = styled((theme) => ({
  fileInput: {
    display: 'none',
  },
  chooseFileButton: {
    marginRight: theme.spacing(2),
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  },
}));

const SwitchContainer = ({ children }) => (
  <Stack direction="row" justifyContent="start" alignItems="center" spacing={1}>
    {children}
  </Stack>
);


const ProcessTrackerReport = () => {
  const location = useLocation();
  const navigate = useNavigate();
  // eslint-disable-next-line no-restricted-globals
  const token =
    'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJldmVudGxpc3QiOlt7IlVzZXJJRCI6IjEiLCJMb2dpbkNvZGUiOiIwMSIsIkxvZ2luTmFtZSI6IkFkbWluIiwiRW1haWxJZCI6ImFkbWluQGdtYWlsLmNvbSIsIlVzZXJUeXBlIjoiQURNSU4ifV0sImlhdCI6MTYzODM1NDczMX0.ZW6zEHIXTxfT-QWEzS6-GuY7bRupf2Jc_tp4fXIRabQ';

  // At the beginning of the component

  // Configuration for style API
  const [apiConfig] = useState({
    companyId: sessionStorage.getItem('CompanyId'),
    unitId: sessionStorage.getItem('factoryID'),
    fiscalYear: sessionStorage.getItem('FiscalYear'),
  });

  const classes = useStyles();
  const currentDate = new Date();
  const [fromDate, setFromDate] = useState(moment(currentDate).startOf('month').format('YYYY-MM-DD'));
  const [toDate, setToDate] = useState(moment(currentDate).format('YYYY-MM-DD'));
  const [styleData, setstyleData] = useState([]);
  const [styleDesc, setStyleDesc] = useState([]);
  const [reportType, setReportType] = useState('Day');
  const [styleSelected, setStyleSelected] = useState({
    Srhid: '0',
    StyleDescription: `All`,
  });
  const [styleNumberSelected,setStyleNumberSelected] = useState({
    Srhid: '0',
    StyleNumber: `All`,
  });
  const [unitData, setUnitData] = useState([]);
  const [unitSelected, setUnitSelected] = useState({
    Unit_Id: '0',
    Unit_Name: 'All',
  });
  const [buyerData, setbuyerData] = useState([]);
  const [buyerSelected, setbuyerSelected] = useState({
    Buyer_Id: '0',
    Buyer_Name: 'All',
  });
  const [filteredData, setFilteredData] = useState([]);

  // Filter style numbers based on selected style description's OB reference
const [filteredStyleNumbers, setFilteredStyleNumbers] = useState([]);

// Update filtered style numbers when style description changes
useEffect(() => {
  if (styleSelected.Srhid === '0' || styleSelected.ObRef === '0') {
    // Show all style numbers when "All" is selected or no OB reference
    setFilteredStyleNumbers(styleData);
    setStyleNumberSelected({ Srhid: '0', StyleNumber: 'All' });
  } else {
    // Filter style numbers that have the same OB reference as selected style
    const filtered = styleData.filter(
      (style) => style.StyleDescription === styleSelected.StyleDescription
    );
    setFilteredStyleNumbers(filtered);
    
    // Auto-select the first style number if available
    if (filtered.length > 0) {
      setStyleNumberSelected({ Srhid: '0', StyleNumber: 'All' });
    } else {
      setStyleNumberSelected({ Srhid: '0', StyleNumber: 'No Style Numbers' });
    }
  }
}, [styleSelected, styleData]);

const handleStyleDescriptionChange = (e, newValue) => {
  const selectedStyle = newValue || { Srhid: '0', StyleDescription: 'All' };
  setStyleSelected(selectedStyle);
  
  // Reset style number when style description changes
  if (selectedStyle.Srhid === '0') {
    setStyleNumberSelected({ Srhid: '0', StyleNumber: 'All' });
  }
};



  const resetFilters = (ReportType) => {

  setFromDate(
    moment(currentDate)
      .startOf('month')
      .format('YYYY-MM-DD')
  );

  setToDate(
    moment(currentDate)
      .format('YYYY-MM-DD')
  );

  setStyleSelected({
    Srhid: '0',
    StyleDescription: 'All',
  });

  setStyleNumberSelected({
    Srhid: '0',
    StyleNumber: 'All',
  });

  setUnitSelected({
    Unit_Id: '0',
    Unit_Name: 'All',
  });

  setbuyerSelected({
    Buyer_Id: '0',
    Buyer_Name: 'All',
  });

  setFilteredData([]);

  // Single select reset
  if (ReportType === 'Day') {

    setSelectedProcess({
      ProcessId: '',
      ProcessName: '',
    });

  } else {

    setSelectedProcess({
      ProcessId: 0,
      ProcessName: 'All',
    });
  }

  setSummary(false);
  setSummaryVisible(false);
  setStyleNumberVisible(false);

  // Multi select reset for Production
  const allIds = processData.map((p) =>
    p.ProcessId.toString()
  );

  const allNames = processData.map((p) =>
    p.ProcessName
  );

  setSelectedProcessIds(allIds);
  setSelectedProcessNames(allNames);
  setIsAllProcessesSelected(true);

  // setReportType('Hour');
};

  // other states
  const [openLoader, setOpenLoader] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [showNoResultsSnackbar, setShowNoResultsSnackbar] = useState(false);
  const [noResultsMessage, setNoResultsMessage] = useState('');
  const [expanded, setExpanded] = React.useState(true);
  // pagination
  const totalRows = filteredData.length;
  const totalPages = Math.ceil(totalRows / rowsPerPage);
  const currentPage = Math.max(0, Math.min(page, totalPages - 1));
  const [processData, setProcessData] = useState([]);
  const [selectedProcess, setSelectedProcess] = useState({ ProcessId: '', ProcessName: '' });
  const [processOrder, setProcessOrder] = useState([]);
  const [obProduction, setObProduction] = useState(true);
  const [summary, setSummary] = useState(false);

  const [imagePreviewOpen, setImagePreviewOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState('');
  const [selectedImageStyle, setSelectedImageStyle] = useState({});
  const [styleNumberVisible,setStyleNumberVisible] = useState(false)
  const [summaryVisible,setSummaryVisible] = useState(false)
  const [hasAutoAppliedFromDashboard, setHasAutoAppliedFromDashboard] = useState(false);
  const isFromDashboard = Boolean(location?.state?.autoApplyProcessTracker);

  const [open, setOpen] = useState(false);
  const [minimized, setMinimized] = useState(false);

  const [selectedProcessIds, setSelectedProcessIds] = useState([]);
  const [selectedProcessNames, setSelectedProcessNames] = useState([]);
  const [isAllProcessesSelected, setIsAllProcessesSelected] = useState(true);

  
  useEffect(() => {
  if (reportType === 'Production' && processData.length > 0) {

    const allIds = processData.map(
      (p) => p.ProcessId.toString()
    );

    const allNames = processData.map(
      (p) => p.ProcessName
    );

    setSelectedProcessIds(allIds);
    setSelectedProcessNames(allNames);
    setIsAllProcessesSelected(true);
  }
}, [processData, reportType]);

    const [detailsData, setdetailsData] = useState([])
  // API Integration
  useEffect(() => {
    GetAllActiveProductionUnits();
    getAllStyles();
    GetAllActiveBuyers();
    getAllProcessData();
    GetOneControl();
    getProcessOrder();
  }, []);


const handleStyleNumberChange = (e, newValue) => {
  if (!newValue) {
    // Clear clicked → reset to "All"
    setStyleNumberSelected({ Srhid: '0', StyleNumber: 'All' });
    setSummaryVisible(false)
    return;
  }

  setStyleNumberSelected(newValue);
    if(newValue.StyleNumber === 'All') 
    {setSummaryVisible(false) }
  else{ setSummaryVisible(true)}
};


const handlehidevisible =()=>{
  if(!summary){
  setStyleNumberVisible(true)
}
else{
   setStyleNumberVisible(false)
}
}
  const getAllProcessData = async (processId = 0) => {
    try {
      const userId = sessionStorage.getItem('UserID');
      const res = await axios.instance.get(`/GetAllProcessData/${processId}`, {
        headers: { Authorization: token, 'Content-Type': 'application/json' },
      });
      setProcessData(res.data);
      return res.data;
    } catch (error) {
      console.error('Error fetching process data:', error);
      return [];
    }
  };

  const GetOneControl = async () => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get(
        `/GetOneControlCenter/${sessionStorage.getItem('factoryID')}/${sessionStorage.getItem('CompanyId')}`,
        {
          headers: { Authorization: token, 'Content-Type': 'application/json' },
        }
      );
      if (res.data.length > 0) {
        res.data.forEach((data) => {
          setObProduction(data.OBProduction === 'Y');
        });
      } else {
        setObProduction(false);
      }
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const handleProcessChange = async (event) => {
    const selectedProcessId = event.target.value;

    // Ask confirmation only if there is existing filtered data
    if (filteredData.length > 0) {
      const confirmChange = window.confirm(
        'Changing the process will reset the current results, and new results will be loaded based on the selected process.\n\nDo you want to continue?'
      );
      if (!confirmChange) return;
    }

    // Clear current data (important: reset before loading new)
    setFilteredData([]);

    // Handle "All" process selection
    if (Number(selectedProcessId) === 0) {
      setSelectedProcess({ ProcessId: 0, ProcessName: 'All' });
      return;
    }

    // Handle specific process selection
    const selectedProcessObj = processData.find((process) => process.ProcessId.toString() === selectedProcessId);

    setSelectedProcess(selectedProcessObj);
  };

  // Handle multi-select process change
const handleProcessMultiChange = (event) => {
  const value = event.target.value;
  
  // Check if "All" is selected
  if (value.includes('all')) {
    if (isAllProcessesSelected) {
      // If already all selected, deselect everything
      setSelectedProcessIds([]);
      setSelectedProcessNames([]);
      setIsAllProcessesSelected(false);
    } else {
      // Select all processes
      const allIds = processData.map(p => p.ProcessId.toString());
      const allNames = processData.map(p => p.ProcessName);
      setSelectedProcessIds(allIds);
      setSelectedProcessNames(allNames);
      setIsAllProcessesSelected(true);
    }
  } else {
    // Handle individual selections
    setSelectedProcessIds(value);
    const selectedNames = processData
      .filter(p => value.includes(p.ProcessId.toString()))
      .map(p => p.ProcessName);
    setSelectedProcessNames(selectedNames);
    setIsAllProcessesSelected(value.length === processData.length);
  }
  
  // Clear filtered data when process selection changes
  if (filteredData.length > 0) {
    setFilteredData([]);
  }
};

// Helper function to get process IDs for API
const getProcessIdsForAPI = () => {
  if (isAllProcessesSelected || selectedProcessIds.length === 0) {
    return '0'; // '0' represents All processes
  }
  return selectedProcessIds.join(',');
};

  // const handleProcessChange = async (event) => {
  //   const selectedProcessId = event.target.value;

  //   const selectedProcessObj = processData.find((process) => process.ProcessId.toString() === selectedProcessId);

  //   if (Number(selectedProcessId) === 0) {
  //     setSelectedProcess({ ProcessId: 0, ProcessName: 'All' });
  //     return;
  //   }
  //   setSelectedProcess(selectedProcessObj);
  // };

  // get all Active Buyer data
  const GetAllActiveBuyers = async () => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get('/GetAllActiveBuyers', {
        headers: { Authorization: token, 'Content-Type': 'application/json' },
      });
      setbuyerData(res.data);
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  // get all Style data
  const getAllStyles = async () => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get(
        `/GetStyleDetails/${apiConfig.companyId}/${apiConfig.unitId}/${apiConfig.fiscalYear}/Y`,
        // '/getAllDailyStyles',
        {
          headers: { Authorization: token, 'Content-Type': 'application/json' },
        }
      );
      setstyleData(res.data);
      const uniqueStyles = filterUniqueByDescription(res.data);
      setStyleDesc(uniqueStyles);
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const filterUniqueByDescription = (data) => {
  const seen = new Map(); // Use Map to track the first occurrence
  const uniqueItems = [];
  
  // Sort by Obref descending (or ObNo if you prefer) to keep the newest/highest
  const sortedData = [...data].sort((a, b) => parseInt(b.Obref) - parseInt(a.Obref));
  
  sortedData.forEach(item => {
    const description = item.StyleDescription.trim();
    if (!seen.has(description)) {
      seen.set(description, true);
      uniqueItems.push(item);
    }
  });
  // Sort back by Obref if needed
  return uniqueItems;
};
  // get all unit data
  const GetAllActiveProductionUnits = async () => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get(`/GetAllActiveProductionUnits/${sessionStorage.getItem('UserID')}`, {
        headers: { Authorization: token, 'Content-Type': 'application/json' },
      });
      setUnitData(res.data);
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

 const applyFilters = async (overrides = {}) => {
    const effectiveReportType = overrides.reportType ?? reportType;
    const effectiveFromDate = overrides.fromDate ?? fromDate;
    const effectiveToDate = overrides.toDate ?? toDate;
    const effectiveStyleSelected = overrides.styleSelected ?? styleSelected;
    const effectiveStyleNumberSelected = overrides.styleNumberSelected ?? styleNumberSelected;
    const effectiveBuyerSelected = overrides.buyerSelected ?? buyerSelected;
    const effectiveUnitSelected = overrides.unitSelected ?? unitSelected;
    const effectiveSelectedProcess = overrides.selectedProcess ?? selectedProcess;
    const effectiveSummary = overrides.summary ?? summary;

    // NEW: Get process IDs for API (supporting multi-select)
    let processIdsForAPI = '0';
    let processNameForAPI = 'All';

    if (effectiveReportType === 'Day') {
        // For Day report, use single select
        if (effectiveSelectedProcess.ProcessId && effectiveSelectedProcess.ProcessId !== '') {
            processIdsForAPI = effectiveSelectedProcess.ProcessId.toString();
            processNameForAPI = effectiveSelectedProcess.ProcessName;
        } else if (selectedProcessIds.length > 0 && !isAllProcessesSelected) {
            // Use first selected process from multi-select as fallback
            processIdsForAPI = selectedProcessIds[0];
            const selectedProc = processData.find(p => p.ProcessId.toString() === selectedProcessIds[0]);
            processNameForAPI = selectedProc?.ProcessName || '';
        } else {
            setShowNoResultsSnackbar(true);
            setNoResultsMessage('Please Select Process');
            return;
        }
    } else {
        // For Style and Production reports, use multi-select logic
        if (isAllProcessesSelected || selectedProcessIds.length === 0) {
            processIdsForAPI = '0';
            processNameForAPI = 'All';
        } else {
            processIdsForAPI = selectedProcessIds.join(',');
            processNameForAPI = selectedProcessNames.join(',');
        }
    }

    // Validation checks
    if (effectiveReportType === 'Day' && processIdsForAPI === '0') {
        setShowNoResultsSnackbar(true);
        setNoResultsMessage('Please Select Process');
        return;
    }
    if ((effectiveReportType === 'Style' || effectiveReportType === 'Production') && processIdsForAPI === '') {
        setShowNoResultsSnackbar(true);
        setNoResultsMessage('Please Select Process');
        return;
    }

    setOpenLoader(true);
    try {
        const res = await axios.instance.post(
            `/GetProcessTrackerReport`,
            {
                FromDate: effectiveFromDate,
                ToDate: effectiveToDate,
                styleId: effectiveStyleSelected.Srhid,
                StyleDescription: effectiveStyleSelected.StyleDescription,
                StyleNumber: effectiveStyleNumberSelected.StyleNumber,
                BuyerId: effectiveBuyerSelected.Buyer_Id,
                companyId: sessionStorage.getItem('CompanyId'),
                factoryId: effectiveUnitSelected.Unit_Id,
                processId: processIdsForAPI,  
                ReportType: effectiveReportType,
                IsOBProduction: obProduction ? 'Y' : 'N',
                ProcessType: processNameForAPI,
                Summary: effectiveSummary ? 'Y' : 'N',
            },
            {
                headers: { Authorization: token, 'Content-Type': 'application/json' },
            }
        );
        setFilteredData(res.data);
        setPage(0);
        setOpenLoader(false);
        setShowNoResultsSnackbar(false);
    } catch (error) {
        console.error('Error fetching data:', error);
    }
};

  useEffect(() => {
    const dashboardDate = location?.state?.dashboardDate;
    const shouldAutoApply = location?.state?.autoApplyProcessTracker;
    const requestedProcessId = Number(location?.state?.processId || 0);
    const requestedProcessName = (location?.state?.processName || 'All').toString().trim();

    if (!shouldAutoApply || !dashboardDate || hasAutoAppliedFromDashboard) {
      return;
    }

    // Wait until process list is loaded if a specific process was requested.
    if ((requestedProcessId > 0 || requestedProcessName.toLowerCase() !== 'all') && processData.length === 0) {
      return;
    }

    const parsedDate = moment(dashboardDate, 'YYYY-MM-DD', true);
    const fallbackDate = moment(dashboardDate);
    const selectedDate = parsedDate.isValid()
      ? parsedDate.format('YYYY-MM-DD')
      : fallbackDate.isValid()
      ? fallbackDate.format('YYYY-MM-DD')
      : moment().format('YYYY-MM-DD');

    const allStyleSelection = { Srhid: '0', StyleDescription: 'All' };
    const allStyleNumberSelection = { Srhid: '0', StyleNumber: 'All' };
    const allProcessSelection = { ProcessId: 0, ProcessName: 'All' };
    const allBuyerSelection = { Buyer_Id: '0', Buyer_Name: 'All' };
    const allUnitSelection = { Unit_Id: '0', Unit_Name: 'All' };

    const matchedProcessById = requestedProcessId > 0
      ? processData.find((process) => Number(process?.ProcessId) === requestedProcessId)
      : null;

    const matchedProcessByName = processData.find((process) => {
      const processName = (process?.ProcessName || '').toString().trim().toLowerCase();
      const requestedName = requestedProcessName.toLowerCase();
      return processName === requestedName || processName.includes(requestedName) || requestedName.includes(processName);
    });

    const matchedProcess = matchedProcessById || matchedProcessByName;

    const selectedProcessForAutoApply =
      requestedProcessName.toLowerCase() === 'all' || !matchedProcess
        ? allProcessSelection
        : {
            ProcessId: matchedProcess.ProcessId,
            ProcessName: matchedProcess.ProcessName,
          };

    setReportType('Production');
    setFromDate(selectedDate);
    setToDate(selectedDate);
    setSummary(true);
    setSummaryVisible(false);
    setStyleNumberVisible(false);
    setStyleSelected(allStyleSelection);
    setStyleNumberSelected(allStyleNumberSelection);
    setSelectedProcess(selectedProcessForAutoApply);
    setbuyerSelected(allBuyerSelection);
    setUnitSelected(allUnitSelection);

    setHasAutoAppliedFromDashboard(true);
    applyFilters({
      reportType: 'Production',
      fromDate: selectedDate,
      toDate: selectedDate,
      summary: true,
      styleSelected: allStyleSelection,
      styleNumberSelected: allStyleNumberSelection,
      selectedProcess: selectedProcessForAutoApply,
      buyerSelected: allBuyerSelection,
      unitSelected: allUnitSelection,
    });
  }, [location?.state, hasAutoAppliedFromDashboard, processData]);

  const handleCloseSnackbar = () => {
    setShowNoResultsSnackbar(false);
  };

  const handleExpansion = () => {
    setExpanded((prevExpanded) => !prevExpanded);
  };

    const exportToExcel = () => {
  if (filteredData.length === 0) {
    setShowNoResultsSnackbar(true);
    setNoResultsMessage('No data to export');
    return;
  }

  const wb = XLSXS.utils.book_new();

  if (reportType === 'Production') {
    createProductionExcel(wb);
  } else {
    // Keep existing logic for other report types
    const data = getExcelData();
    const headers = getExcelHeaders();
    console.log(headers, 'headers');
    const startRow = 8;

    const ws = XLSXS.utils.json_to_sheet(data, { origin: `A${startRow}`, header: headers });
    const columns = headers.map((_, index) => String.fromCharCode(65 + index));

    setupExcelHeaders(ws, columns, startRow);
    styleExcelHeaders(ws, columns, startRow);
    styleExcelData(ws, columns, data.length, startRow, headers);
    addTotalRow(ws, columns, data.length, startRow);

    // Extend !ref to include title rows (row 1+) and the total row
    const lastCol = columns[columns.length - 1];
    ws['!ref'] = `A1:${lastCol}${data.length + startRow + 1}`;

    XLSXS.utils.book_append_sheet(wb, ws, `${reportType} Report`);
  }

  const currentDate = moment().format('DD-MM-YYYY');
  const processName = isAllProcessesSelected ? 'AllProcesses' : (selectedProcessNames.length ? selectedProcessNames.join('_') : 'Selected');
  const summaryText = summary ? '_Summary' : '';
  XLSXS.writeFile(wb, `ProcessTracker_${reportType}_${processName}_${currentDate}${summaryText}.xlsx`);
};
 
// const createProductionExcel = (wb) => {
//   // Prepare data for Excel
//   const excelData = [];

//   // 1. Add title row
//   excelData.push(['Process Tracker Report - Process Wise']);

//   // 2. Add filter information
//   const filterInfo = getFilterInformation();
//   filterInfo.forEach((info) => {
//     excelData.push([info]);
//   });

//   // 3. Add empty row
//   excelData.push([]);

//   // 4. Add main headers
//   const mainHeaders = ['SNo'];
  
//   // Conditionally add columns based on summary mode
//   if (!summary) {
//     mainHeaders.push('Process Date');
//   }
  
//   mainHeaders.push('Style Description');
  
//   if (!summary) {
//     mainHeaders.push('Style Number');
//   }
  
//   mainHeaders.push('Order Qty');

//   // Add process headers with Qty/Value subheaders
//   if (selectedProcess.ProcessId === 0) {
//     processOrder.forEach((process) => {
//       mainHeaders.push(process); // This will span 2 columns (Qty & Value)
//       mainHeaders.push('');
//     });
//   } else {
//     mainHeaders.push(selectedProcess.ProcessName);
//     mainHeaders.push('');
//   }

//   // Add Row Total headers
//   mainHeaders.push('Total Value');

//   excelData.push(mainHeaders);

//   // 5. Add subheaders row
//   const subHeaders = ['']; // Start with SNo
  
//   // Conditionally add empty subheaders based on summary mode
//   if (!summary) {
//     subHeaders.push(''); // For Process Date
//   }
  
//   subHeaders.push(''); // For Style Description
  
//   if (!summary) {
//     subHeaders.push(''); // For Style Number
//   }
  
//   subHeaders.push(''); // For Order Qty

//   if (selectedProcess.ProcessId === 0) {
//     processOrder.forEach(() => {
//       subHeaders.push('Qty', 'Value');
//     });
//   } else {
//     subHeaders.push('Qty', 'Value');
//   }

//   // Add Row Total subheaders
//   subHeaders.push('');

//   excelData.push(subHeaders);

//   // 6. Add data rows
//   filteredData.forEach((item, index) => {
//     const row = [index + 1]; // Start with SNo
    
//     // Conditionally add Process Date
//     if (!summary) {
//       row.push(moment(item.ProcessDate).format('DD-MM-YYYY'));
//     }
    
//     row.push(item.StyleDescription || '');
    
//     // Conditionally add Style Number
//     if (!summary) {
//       row.push(item.StyleNumber || '');
//     }
    
//     row.push(item.OrderQty || 0);

//     let rowTotalValue = 0;

//     // Add process quantities and values
//     if (selectedProcess.ProcessId === 0) {
//       processOrder.forEach((process) => {
//         const qty = getProcessQuantity1(item, process) || 0;
//         const valueStr = getProcessValue(item, process) || '0.00';
//         const value =
//           typeof valueStr === 'string' ? parseFloat(valueStr.replace(/,/g, '')) || 0 : parseFloat(valueStr) || 0;

//         row.push(qty);
//         row.push(valueStr);
//         rowTotalValue += value;
//       });
//     } else {
//       const qty = getProcessQuantity1(item, selectedProcess.ProcessName) || 0;
//       const valueStr = getProcessValue(item, selectedProcess.ProcessName) || '0.00';
//       const value =
//         typeof valueStr === 'string' ? parseFloat(valueStr.replace(/,/g, '')) || 0 : parseFloat(valueStr) || 0;

//       row.push(qty);
//       row.push(valueStr);
//       rowTotalValue = value;
//     }

//     // Add row totals
//     row.push(rowTotalValue.toFixed(2));

//     excelData.push(row);
//   });

//   // 7. Add TOTAL row
//   const totalRow = ['TOTAL'];
  
//   // Conditionally add empty cells for Process Date
//   if (!summary) {
//     totalRow.push('');
//   }
  
//   totalRow.push(''); // For Style Description
  
//   // Conditionally add empty cells for Style Number
//   if (!summary) {
//     totalRow.push('');
//   }
  
//   totalRow.push(''); // For Order Qty

//   let grandTotalQty = 0;
//   let grandTotalValue = 0;

//   if (selectedProcess.ProcessId === 0) {
//     processOrder.forEach((processName) => {
//       // Qty total
//       const qtyTotal = filteredData.reduce(
//         (sum, item) => sum + (parseFloat(getProcessQuantity1(item, processName)) || 0),
//         0
//       );
//       totalRow.push(qtyTotal);
//       grandTotalQty += qtyTotal;

//       // Value total
//       const valueTotal = filteredData.reduce((sum, item) => {
//         const valueStr = getProcessValue(item, processName);
//         const value =
//           typeof valueStr === 'string' ? parseFloat(valueStr.replace(/,/g, '')) || 0 : parseFloat(valueStr) || 0;
//         return sum + value;
//       }, 0);
//       totalRow.push(valueTotal.toFixed(2));
//       grandTotalValue += valueTotal;
//     });
//   } else {
//     // Single process totals
//     const qtyTotal = filteredData.reduce(
//       (sum, item) => sum + (parseFloat(getProcessQuantity1(item, selectedProcess.ProcessName)) || 0),
//       0
//     );
//     totalRow.push(qtyTotal);
//     grandTotalQty = qtyTotal;

//     const valueTotal = filteredData.reduce((sum, item) => {
//       const valueStr = getProcessValue(item, selectedProcess.ProcessName);
//       const value =
//         typeof valueStr === 'string' ? parseFloat(valueStr.replace(/,/g, '')) || 0 : parseFloat(valueStr) || 0;
//       return sum + value;
//     }, 0);
//     totalRow.push(valueTotal.toFixed(2));
//     grandTotalValue = valueTotal;
//   }

//   // Add grand totals for Row Total columns
//   totalRow.push(grandTotalValue.toFixed(2));

//   excelData.push(totalRow);

//   // Create worksheet from array data
//   const ws = XLSXS.utils.aoa_to_sheet(excelData);

//   // Apply styling
//   applyProductionExcelStyling(ws, excelData, processOrder, selectedProcess.ProcessId === 0, summary);

//   XLSXS.utils.book_append_sheet(wb, ws, 'Production Report');
// };
 
const createProductionExcel = (wb) => {
  if (filteredData.length === 0) {
    setShowNoResultsSnackbar(true);
    setNoResultsMessage('No data to export');
    return;
  }

  // MULTI SELECT SUPPORT
  const displayProcesses = isAllProcessesSelected
    ? processOrder
    : selectedProcessNames;

  // Prepare data for Excel
  const excelData = [];

  // 1. Add title row
  excelData.push(['Process Tracker Report - Process Wise']);

  // 2. Add filter information
  const filterInfo = getFilterInformation();
  filterInfo.forEach((info) => {
    excelData.push([info]);
  });

  // 3. Add empty row
  excelData.push([]);

  // 4. Add main headers
  const mainHeaders = ['SNo'];

  // Conditionally add columns based on summary mode
  if (!summary) {
    mainHeaders.push('Process Date');
  }

  mainHeaders.push('Style Description');

  if (!summary) {
    mainHeaders.push('Style Number');
  }

  // Add Delivery Date ONLY in summary mode for Production report
  if (summary) {
    mainHeaders.push('Delivery Date');
  }

  mainHeaders.push('Order Qty');

  // MULTI SELECT PROCESS HEADERS
  displayProcesses.forEach((process) => {
    mainHeaders.push(process);
    mainHeaders.push('');
  });

  // Add Row Total headers
  mainHeaders.push('Total Value');

  excelData.push(mainHeaders);

  // 5. Add subheaders row
  const subHeaders = [''];

  // Conditionally add empty subheaders based on summary mode
  if (!summary) {
    subHeaders.push('');
  }

  subHeaders.push('');

  if (!summary) {
    subHeaders.push('');
  }

  // Add Delivery Date subheader ONLY in summary mode
  if (summary) {
    subHeaders.push('');
  }

  subHeaders.push('');

  // MULTI SELECT QTY / VALUE HEADERS
  displayProcesses.forEach(() => {
    subHeaders.push('Qty', 'Value');
  });

  // Add Row Total subheaders
  subHeaders.push('');

  excelData.push(subHeaders);

  // 6. Add data rows
  filteredData.forEach((item, index) => {
    const row = [index + 1];

    // Conditionally add Process Date
    if (!summary) {
      row.push(moment(item.ProcessDate).format('DD-MM-YYYY'));
    }

    row.push(item.StyleDescription || '');

    // Conditionally add Style Number
    if (!summary) {
      row.push(item.StyleNumber || '');
    }

    // Add Delivery Date ONLY in summary mode
    if (summary) {
      row.push(
        item.DeliveryDate
          ? moment(item.DeliveryDate).format('DD-MM-YYYY')
          : ''
      );
    }

    row.push(item.OrderQty || 0);

    let rowTotalValue = 0;

    // MULTI SELECT PROCESS DATA
    displayProcesses.forEach((process) => {
      const qty =
        getProcessQuantity1(item, process) || 0;

      const valueStr =
        getProcessValue(item, process) || '0.00';

      const value =
        typeof valueStr === 'string'
          ? parseFloat(valueStr.replace(/,/g, '')) || 0
          : parseFloat(valueStr) || 0;

      row.push(qty);
      row.push(valueStr);

      rowTotalValue += value;
    });

    // Add row totals
    row.push(rowTotalValue.toFixed(2));

    excelData.push(row);
  });

  // 7. Add TOTAL row
  const totalRow = ['TOTAL'];

  // Conditionally add empty cells for Process Date
  if (!summary) {
    totalRow.push('');
  }

  totalRow.push('');

  // Conditionally add empty cells for Style Number
  if (!summary) {
    totalRow.push('');
  }

  // Add empty cell for Delivery Date if in summary mode
  if (summary) {
    totalRow.push('');
  }

  totalRow.push('');

  let grandTotalQty = 0;
  let grandTotalValue = 0;

  // MULTI SELECT TOTALS
  displayProcesses.forEach((processName) => {

    // Qty total
    const qtyTotal = filteredData.reduce(
      (sum, item) =>
        sum +
        (parseFloat(
          getProcessQuantity1(item, processName)
        ) || 0),
      0
    );

    totalRow.push(qtyTotal);

    grandTotalQty += qtyTotal;

    // Value total
    const valueTotal = filteredData.reduce((sum, item) => {

      const valueStr =
        getProcessValue(item, processName);

      const value =
        typeof valueStr === 'string'
          ? parseFloat(valueStr.replace(/,/g, '')) || 0
          : parseFloat(valueStr) || 0;

      return sum + value;

    }, 0);

    totalRow.push(valueTotal.toFixed(2));

    grandTotalValue += valueTotal;
  });

  // Add grand totals for Row Total columns
  totalRow.push(grandTotalValue.toFixed(2));

  excelData.push(totalRow);

  // Create worksheet from array data
  const ws = XLSXS.utils.aoa_to_sheet(excelData);

  // Apply styling
  applyProductionExcelStyling(
    ws,
    excelData,
    displayProcesses,
    isAllProcessesSelected,
    summary
  );

  XLSXS.utils.book_append_sheet(
    wb,
    ws,
    'Production Report'
  );
};
const applyProductionExcelStyling = (ws, data, processOrder, isAllProcesses, isSummary) => {
  // Define styles
  const titleStyle = {
    font: { bold: true, sz: 16 },
    alignment: { horizontal: 'center', vertical: 'center' },
    fill: { fgColor: { rgb: '88a3ca' } },
  };

  const filterStyle = {
    font: { bold: true, sz: 11 },
    fill: { fgColor: { rgb: 'e3f2fd' } },
  };

  const mainHeaderStyle = {
    fill: { fgColor: { rgb: '219C90' } },
    alignment: { horizontal: 'center', vertical: 'center' },
    font: { bold: true, sz: 12, color: { rgb: 'FFFFFF' } },
    border: {
      left: { style: 'thin', color: { rgb: '000000' } },
      top: { style: 'thin', color: { rgb: '000000' } },
      right: { style: 'thin', color: { rgb: '000000' } },
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  };

  const subHeaderStyle = {
    fill: { fgColor: { rgb: '4CAF50' } },
    alignment: { horizontal: 'center', vertical: 'center' },
    font: { bold: true, sz: 11, color: { rgb: 'FFFFFF' } },
    border: {
      left: { style: 'thin', color: { rgb: '000000' } },
      top: { style: 'thin', color: { rgb: '000000' } },
      right: { style: 'thin', color: { rgb: '000000' } },
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  };

  const dataStyle = {
    alignment: { horizontal: 'center' },
    border: {
      left: { style: 'thin', color: { rgb: '000000' } },
      top: { style: 'thin', color: { rgb: '000000' } },
      right: { style: 'thin', color: { rgb: '000000' } },
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  };

  const rowTotalStyle = {
    alignment: { horizontal: 'center' },
    font: { bold: true },
    fill: { fgColor: { rgb: 'f5f5f5' } },
    border: {
      left: { style: 'thin', color: { rgb: '000000' } },
      top: { style: 'thin', color: { rgb: '000000' } },
      right: { style: 'thin', color: { rgb: '000000' } },
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  };

  const totalRowStyle = {
    font: { bold: true },
    alignment: { horizontal: 'center' },
    fill: { fgColor: { rgb: 'e3f2fd' } },
    border: {
      left: { style: 'thin', color: { rgb: '000000' } },
      top: { style: 'thin', color: { rgb: '000000' } },
      right: { style: 'thin', color: { rgb: '000000' } },
      bottom: { style: 'thin', color: { rgb: '000000' } },
    },
  };

  // Calculate total columns count based on summary mode
  const baseColumns = 1; // SNo
  const dateColumn = isSummary ? 0 : 1; // Process Date if not summary
  const styleDescColumn = 1; // Style Description
  const styleNumberColumn = isSummary ? 0 : 1; // Style Number if not summary
  const deliveryDateColumn = isSummary ? 1 : 0; // Delivery Date if in summary mode
  const orderQtyColumn = 1; // Order Qty
  const processColumns = isAllProcesses ? processOrder.length * 2 : 2;
  const rowTotalColumns = 1; // Total Value
  
  const totalColumns = baseColumns + dateColumn + styleDescColumn + styleNumberColumn + deliveryDateColumn + orderQtyColumn + processColumns + rowTotalColumns;

  // Apply styles and merges
  const range = XLSXS.utils.decode_range(ws['!ref']);
  if (!ws['!merges']) ws['!merges'] = [];

  // Title merge (row 0)
  ws['!merges'].push({
    s: { r: 0, c: 0 },
    e: { r: 0, c: totalColumns - 1 },
  });

  // Filter info merges
  const filterInfoCount = getFilterInformation().length;
  for (let i = 1; i <= filterInfoCount; i += 1) {
    ws['!merges'].push({
      s: { r: i, c: 0 },
      e: { r: i, c: totalColumns - 1 },
    });
  }

  // Main header merges for process columns
  const mainHeaderRow = filterInfoCount + 2;
  
  // Calculate starting column index for process headers (after all base columns)
  let currentCol = baseColumns + dateColumn + styleDescColumn + styleNumberColumn + deliveryDateColumn + orderQtyColumn;

  if (isAllProcesses) {
    processOrder.forEach(() => {
      // Merge each process name over Qty and Value columns
      ws['!merges'].push({
        s: { r: mainHeaderRow, c: currentCol },
        e: { r: mainHeaderRow, c: currentCol + 1 },
      });
      currentCol += 2;
    });
  } else {
    // Single process - merge the process name over Qty/Value
    ws['!merges'].push({
      s: { r: mainHeaderRow, c: currentCol },
      e: { r: mainHeaderRow, c: currentCol + 1 },
    });
    currentCol += 2;
  }

  // Apply styles to each cell
  for (let rowNum = range.s.r; rowNum <= range.e.r; rowNum += 1) {
    for (let colNum = range.s.c; colNum <= range.e.c; colNum += 1) {
      const cellAddress = { c: colNum, r: rowNum };
      const cellRef = XLSXS.utils.encode_cell(cellAddress);

      if (ws[cellRef]) {
        // Title row
        if (rowNum === 0) {
          ws[cellRef].s = titleStyle;
        }
        // Filter rows
        else if (rowNum >= 1 && rowNum <= filterInfoCount) {
          ws[cellRef].s = filterStyle;
        }
        // Main header row
        else if (rowNum === mainHeaderRow) {
          ws[cellRef].s = mainHeaderStyle;

          // For merged cells, ensure content is only in the first cell
          const isMergedCell = ws['!merges'].some(
            (merge) => colNum > merge.s.c && colNum <= merge.e.c && rowNum === merge.s.r
          );
          if (isMergedCell) {
            // Clear content from the second cell of merged range
            ws[cellRef].v = '';
          }
        }
        // Subheader row
        else if (rowNum === mainHeaderRow + 1) {
          ws[cellRef].s = subHeaderStyle;
        }
        // Data rows
        else if (rowNum > mainHeaderRow + 1 && rowNum < data.length - 1) {
          // Check if this is a row total column (last column)
          if (colNum >= totalColumns - 1) {
            ws[cellRef].s = rowTotalStyle;
          } else {
            ws[cellRef].s = dataStyle;
          }
        }
        // Total row
        else if (rowNum === data.length - 1) {
          ws[cellRef].s = totalRowStyle;
        }
      }
    }
  }

  // Set column widths based on summary mode
  const colWidths = [
    { wch: 6 }, // SNo
  ];

  // Add width for Process Date if NOT in summary mode
  if (!isSummary) {
    colWidths.push({ wch: 12 }); // Process Date
  }

  colWidths.push({ wch: 20 }); // Style Description

  // Add width for Style Number if NOT in summary mode
  if (!isSummary) {
    colWidths.push({ wch: 12 }); // Style Number
  }

  // Add width for Delivery Date if IN summary mode
  if (isSummary) {
    colWidths.push({ wch: 12 }); // Delivery Date
  }

  colWidths.push({ wch: 10 }); // Order Qty

  // Add widths for process columns
  if (isAllProcesses) {
    processOrder.forEach(() => {
      colWidths.push({ wch: 8 }); // Qty column
      colWidths.push({ wch: 10 }); // Value column
    });
  } else {
    colWidths.push({ wch: 8 }); // Qty column
    colWidths.push({ wch: 10 }); // Value column
  }

  // Add width for row total column
  colWidths.push({ wch: 12 }); // Total Value

  ws['!cols'] = colWidths;
};
  

//   const getExcelData = () => {
//   return filteredData.map((item, index) => {
//     // Start with base data
//     const baseData = {
//       'S.No': index + 1,
//       'Style Description': item.StyleDescription || '',
//     };

//     // Only include Style Number if summary is false
//     if (!summary) {
//       baseData['Style No'] = item.StyleNumber || '';
//     }

//     baseData['Order Qty'] = item.OrderQty || 0;

//     // Add Process Date only for specific report types AND if summary is false
//     if ((reportType === 'Day' || reportType === 'Production') && !summary) {
//       baseData['Process Date'] = moment(item.ProcessDate).format('DD-MM-YYYY');
//     }

//     switch (reportType) {
//       case 'Day': {
//         return {
//           ...baseData,
//           [`${selectedProcess.ProcessName} Qty`]: item.processQuantity || 0,
//         };
//       }

//       case 'Style': {
//         const styleData = { ...baseData };
        
//         if (selectedProcess.ProcessId === 0) {
//           processOrder.forEach((process) => {
//             styleData[`${process} Qty`] = getProcessQuantity(item, process) || 0;
//           });
//         } else {
//           styleData[`${selectedProcess.ProcessName} Qty`] =
//             getProcessQuantity(item, selectedProcess.ProcessName) || 0;
//         }
//         return styleData;
//       }

//       case 'Production': {
//         const productionData = { ...baseData };
        
//         if (selectedProcess.ProcessId === 0) {
//           processOrder.forEach((process) => {
//             productionData[`${process} Qty`] = getProcessQuantity1(item, process) || 0;
//             productionData[`${process} Value`] = getProcessValue(item, process) || '0.00';
//           });
//         } else {
//           productionData[`${selectedProcess.ProcessName} Qty`] =
//             getProcessQuantity1(item, selectedProcess.ProcessName) || 0;
//           productionData[`${selectedProcess.ProcessName} Value`] =
//             getProcessValue(item, selectedProcess.ProcessName) || '0.00';
//         }

//         let rowTotalValue = 0;

//         if (selectedProcess.ProcessId === 0) {
//           processOrder.forEach((processName) => {
//             const qty = parseFloat(getProcessQuantity1(item, processName)) || 0;
//             const valueStr = getProcessValue(item, processName);
//             const value =
//               typeof valueStr === 'string' ? parseFloat(valueStr.replace(/,/g, '')) || 0 : parseFloat(valueStr) || 0;
//             rowTotalValue += value;
//           });
//         } else {
//           const valueStr = getProcessValue(item, selectedProcess.ProcessName);
//           rowTotalValue =
//             typeof valueStr === 'string' ? parseFloat(valueStr.replace(/,/g, '')) || 0 : parseFloat(valueStr) || 0;
//         }

//         productionData['Row Total Value'] = rowTotalValue;

//         return productionData;
//       }

//       default:
//         return baseData;
//     }
//   });
// };
 
const getExcelData = () => {
  return filteredData.map((item, index) => {
    // Start with base data
    const baseData = {
      'S.No': index + 1,
      'Style Description': item.StyleDescription || '',
    };

    // Only include Style Number if summary is false
    if (!summary) {
      baseData['Style No'] = item.StyleNumber || '';
    }

    // Add Delivery Date ONLY for Style and Production reports
    if (reportType === 'Style' || reportType === 'Production') {
      baseData['Delivery Date'] = item.DeliveryDate ? moment(item.DeliveryDate).format('DD-MM-YYYY') : '';
    }
    
    baseData['Order Qty'] = item.OrderQty || 0;

    // Add Process Date only for Day and Production reports AND if summary is false
    if ((reportType === 'Day' || reportType === 'Production') && !summary) {
      baseData['Process Date'] = moment(item.ProcessDate).format('DD-MM-YYYY');
    }

    switch (reportType) {
      case 'Day': {
        return {
          ...baseData,
          [`${selectedProcess.ProcessName} Qty`]: item.processQuantity || 0,
        };
      }

      case 'Style': {
        const styleData = { ...baseData };
        
        if (selectedProcess.ProcessId === 0) {
          processOrder.forEach((process) => {
            styleData[`${process} Qty`] = getProcessQuantity(item, process) || 0;
          });
        } else {
          styleData[`${selectedProcess.ProcessName} Qty`] =
            getProcessQuantity(item, selectedProcess.ProcessName) || 0;
        }
        return styleData;
      }

      case 'Production': {
        const productionData = { ...baseData };
        
        if (selectedProcess.ProcessId === 0) {
          processOrder.forEach((process) => {
            productionData[`${process} Qty`] = getProcessQuantity1(item, process) || 0;
            productionData[`${process} Value`] = getProcessValue(item, process) || '0.00';
          });
        } else {
          productionData[`${selectedProcess.ProcessName} Qty`] =
            getProcessQuantity1(item, selectedProcess.ProcessName) || 0;
          productionData[`${selectedProcess.ProcessName} Value`] =
            getProcessValue(item, selectedProcess.ProcessName) || '0.00';
        }

        let rowTotalValue = 0;

        if (selectedProcess.ProcessId === 0) {
          processOrder.forEach((processName) => {
            const qty = parseFloat(getProcessQuantity1(item, processName)) || 0;
            const valueStr = getProcessValue(item, processName);
            const value =
              typeof valueStr === 'string' ? parseFloat(valueStr.replace(/,/g, '')) || 0 : parseFloat(valueStr) || 0;
            rowTotalValue += value;
          });
        } else {
          const valueStr = getProcessValue(item, selectedProcess.ProcessName);
          rowTotalValue =
            typeof valueStr === 'string' ? parseFloat(valueStr.replace(/,/g, '')) || 0 : parseFloat(valueStr) || 0;
        }

        productionData['Row Total Value'] = rowTotalValue;

        return productionData;
      }

      default:
        return baseData;
    }
  });
};

//   const getExcelHeaders = () => {

//   const baseHeaders = ['S.No', 'Style Description'];
  
//   // Only include Style Number if summary is false
//   if (!summary) {
//     baseHeaders.push('Style No');
//   }
  
//   baseHeaders.push('Order Qty');

//   switch (reportType) {
//     case 'Day': {
//       const result = [...baseHeaders];
//       // Only include Process Date if summary is false
//       if (!summary) {
//         result.push('Process Date');
//       }
//       result.push(`${selectedProcess.ProcessName} Qty`);
//       return result;
//     }

//     case 'Style': {
//       let result = [...baseHeaders];
//       if (selectedProcess.ProcessId === 0) {
//         result = [...result, ...processOrder.map((process) => `${process} Qty`)];
//       } else {
//         result = [...result, `${selectedProcess.ProcessName} Qty`];
//       }
//       return result;
//     }

//     case 'Production': {
//       // For production report, headers are handled differently in createProductionExcel
//       const result = [...baseHeaders];
//       if (!summary) {
//         result.splice(2, 0, 'Process Date'); // Insert Process Date after Style Description
//       }
//       return result;
//     }

//     default:
//       return baseHeaders;
//   }
// };
const getExcelHeaders = () => {
  const baseHeaders = ['S.No', 'Style Description'];
  
  // Only include Style Number if summary is false
  if (!summary) {
    baseHeaders.push('Style No');
  }
  
  baseHeaders.push('Order Qty');

  switch (reportType) {
    case 'Day': {
      const result = [...baseHeaders];
      // Only include Process Date if summary is false
      if (!summary) {
        // Insert Process Date after Style Number or Style Description
        const styleNumberIndex = result.indexOf('Style No');
        if (styleNumberIndex !== -1) {
          result.splice(styleNumberIndex + 1, 0, 'Process Date');
        } else {
          // If no Style Number, insert after Style Description
          const styleDescIndex = result.indexOf('Style Description');
          result.splice(styleDescIndex + 1, 0, 'Process Date');
        }
      }
      result.push(`${selectedProcess.ProcessName} Qty`);
      return result;
    }

    case 'Style': {
      let result = [...baseHeaders];
      // Insert Delivery Date before Order Qty for Style report
      const orderQtyIndex = result.indexOf('Order Qty');
      result.splice(orderQtyIndex, 0, 'Delivery Date');
      
      if (selectedProcess.ProcessId === 0) {
        result = [...result, ...processOrder.map((process) => `${process} Qty`)];
      } else {
        result = [...result, `${selectedProcess.ProcessName} Qty`];
      }
      return result;
    }

    case 'Production': {
      // For production report, headers are handled in createProductionExcel
      // This return is only used by setupExcelHeaders function
      const result = ['S.No'];
      
      if (!summary) {
        result.push('Process Date');
      }
      
      result.push('Style Description');
      
      if (!summary) {
        result.push('Style Number');
      }
      
      result.push('Delivery Date');
      result.push('Order Qty');
      
      return result;
    }

    default:
      return baseHeaders;
  }
};
const setupExcelHeaders = (ws, columns, startRow) => {
    const title = `Process Tracker Report - ${reportType === 'Production' ? 'Process' : reportType === 'Day' ? 'Process' : 'Style'} Wise`;

    ws['!merges'] = [{ s: { r: 0, c: 0 }, e: { r: 1, c: columns.length - 1 } }];
    ws.A1 = {
      v: title,
      t: 's',
      s: {
        font: { bold: true, sz: 16 },
        alignment: { horizontal: 'center', vertical: 'center' },
        fill: { fgColor: { rgb: '88a3ca' } },
        border: {
          left: { style: 'thin', color: { rgb: '000000' } },
          top: { style: 'thin', color: { rgb: '000000' } },
          right: { style: 'thin', color: { rgb: '000000' } },
          bottom: { style: 'thin', color: { rgb: '000000' } },
        },
      },
    };

    const filterInfo = getFilterInformation();
    filterInfo.forEach((info, index) => {
      const row = 3 + index;
      ws[`A${row}`] = {
        v: info,
        t: 's',
        s: {
          font: { bold: true, sz: 11 },
          fill: { fgColor: { rgb: 'e3f2fd' } },
        },
      };
      ws['!merges'] = [...(ws['!merges'] || []), { s: { r: row - 1, c: 0 }, e: { r: row - 1, c: columns.length - 1 } }];
    });
  };

  const getFilterInformation = () => {
    const filterInfo = [];

    if (reportType === 'Day' || reportType === 'Production') {
      filterInfo.push(
        `From Date: ${moment(fromDate).format('DD-MM-YYYY')} | To Date: ${moment(toDate).format('DD-MM-YYYY')}`
      );
    } else {
      filterInfo.push(`As On Date: ${moment(toDate).format('DD-MM-YYYY')}`);
    }

  filterInfo.push(`Process: ${selectedProcessNames.length > 0 ? selectedProcessNames.join(', ') : 'No Process Selected'}`);
    filterInfo.push(
      `Style: ${styleSelected.StyleDescription === 'All' ? 'All Styles' : styleSelected.StyleDescription}`
    );

    // if (styleSelected.Srhid !== '0') {
    //   filterInfo.push(`Style: ${styleSelected.StyleDescription}`);
    // }

    if (unitSelected.Unit_Id !== '0') {
      filterInfo.push(`Factory: ${unitSelected.Unit_Name}`);
    }

    if (buyerSelected.Buyer_Id !== '0') {
      filterInfo.push(`Buyer: ${buyerSelected.Buyer_Name}`);
    }

    filterInfo.push(`Generated On: ${moment().format('DD-MM-YYYY HH:mm:ss')}`);
    filterInfo.push(`Total Records: ${filteredData.length}`);

    return filterInfo;
  };

  const styleExcelHeaders = (ws, columns, startRow) => {
    columns.forEach((col, colIndex) => {
      const cell = `${col}${startRow}`;
      if (ws[cell]) {
        ws[cell].s = {
          fill: { fgColor: { rgb: '219C90' } },
          alignment: { horizontal: 'center' },
          font: { bold: true, sz: 12, color: { rgb: 'FFFFFF' } },
          border: {
            left: { style: 'thin', color: { rgb: '000000' } },
            top: { style: 'thin', color: { rgb: '000000' } },
            right: { style: 'thin', color: { rgb: '000000' } },
            bottom: { style: 'thin', color: { rgb: '000000' } },
          },
        };
      }
    });
  };

  const styleExcelData = (ws, columns, dataLength, startRow, headers) => {
    const cellStyle = {
      alignment: { horizontal: 'center' },
      border: {
        left: { style: 'thin', color: { rgb: '000000' } },
        top: { style: 'thin', color: { rgb: '000000' } },
        right: { style: 'thin', color: { rgb: '000000' } },
        bottom: { style: 'thin', color: { rgb: '000000' } },
      },
    };

    const rowTotalStyle = {
      ...cellStyle,
      fill: { fgColor: { rgb: 'f5f5f5' } },
      font: { bold: true },
    };

    for (let i = 1; i <= dataLength; i += 1) {
      const rowNumber = i + startRow;
      columns.forEach((col, colIndex) => {
        const cell = `${col}${rowNumber}`;
        if (ws[cell]) {
          if (
            reportType === 'Production' &&
            (headers[colIndex] === 'Row Total Qty' || headers[colIndex] === 'Row Total Value')
          ) {
            ws[cell].s = rowTotalStyle;
          } else {
            ws[cell].s = cellStyle;
          }
        }
      });
    }
  };

  

//   const addTotalRow = (ws, columns, dataLength, startRow) => {
//   const totalRow = dataLength + startRow + 1;
//   const headers = getExcelHeaders();

//   ws[`A${totalRow}`] = {
//     v: 'TOTAL',
//     t: 's',
//     s: {
//       font: { bold: true },
//       alignment: { horizontal: 'center' },
//       fill: { fgColor: { rgb: 'e3f2fd' } },
//       border: {
//         left: { style: 'thin', color: { rgb: '000000' } },
//         top: { style: 'thin', color: { rgb: '000000' } },
//         right: { style: 'thin', color: { rgb: '000000' } },
//         bottom: { style: 'thin', color: { rgb: '000000' } },
//       },
//     },
//   };

//   headers.forEach((header, colIndex) => {
//     if (colIndex > 0) {
//       const col = String.fromCharCode(65 + colIndex);
//       let total = 0;

//       // Skip non-numeric columns in total calculation
//       const nonNumericColumns = ['Style Description', 'Style No', 'Process Date'];
//       if (nonNumericColumns.includes(header)) {
//         return;
//       }

//       if (header.includes('Qty') && !header.includes('Value') && !header.includes('Row Total')) {
//         total = filteredData.reduce((sum, item) => {
//           let value = 0;
//           if (reportType === 'Day') {
//             value = item.processQuantity || 0;
//           } else if (reportType === 'Style') {
//             const processName = header.replace(' Qty', '');
//             value = getProcessQuantity(item, processName) || 0;
//           } else if (reportType === 'Production') {
//             const processName = header.replace(' Qty', '');
//             value = getProcessQuantity1(item, processName) || 0;
//           }
//           return sum + (parseFloat(value) || 0);
//         }, 0);
//       } else if (header.includes('Value') && !header.includes('Row Total')) {
//         total = filteredData.reduce((sum, item) => {
//           let value = 0;
//           if (reportType === 'Production') {
//             const processName = header.replace(' Value', '');
//             const valueStr = getProcessValue(item, processName);
//             value =
//               typeof valueStr === 'string' ? parseFloat(valueStr.replace(/,/g, '')) || 0 : parseFloat(valueStr) || 0;
//           }
//           return sum + value;
//         }, 0);
//       } else if (header === 'Order Qty') {
//         total = filteredData.reduce((sum, item) => {
//           return sum + (parseFloat(item.OrderQty) || 0);
//         }, 0);
//       }

//       if (reportType === 'Production') {
//         if (header === 'Row Total Qty') {
//           total = filteredData.reduce((sum, item) => {
//             let rowTotalQty = 0;
//             if (selectedProcess.ProcessId === 0) {
//               processOrder.forEach((processName) => {
//                 rowTotalQty += parseFloat(getProcessQuantity1(item, processName)) || 0;
//               });
//             } else {
//               rowTotalQty = parseFloat(getProcessQuantity1(item, selectedProcess.ProcessName)) || 0;
//             }
//             return sum + rowTotalQty;
//           }, 0);
//         } else if (header === 'Row Total Value') {
//           total = filteredData.reduce((sum, item) => {
//             let rowTotalValue = 0;
//             if (selectedProcess.ProcessId === 0) {
//               processOrder.forEach((processName) => {
//                 const valueStr = getProcessValue(item, processName);
//                 const value =
//                   typeof valueStr === 'string'
//                     ? parseFloat(valueStr.replace(/,/g, '')) || 0
//                     : parseFloat(valueStr) || 0;
//                 rowTotalValue += value;
//               });
//             } else {
//               const valueStr = getProcessValue(item, selectedProcess.ProcessName);
//               rowTotalValue =
//                 typeof valueStr === 'string'
//                   ? parseFloat(valueStr.replace(/,/g, '')) || 0
//                   : parseFloat(valueStr) || 0;
//             }
//             return sum + rowTotalValue;
//           }, 0);
//         }
//       }

//       const isNumericColumn =
//         header.includes('Qty') ||
//         header.includes('Value') ||
//         header === 'Order Qty' ||
//         header === 'Row Total Qty' ||
//         header === 'Row Total Value';

//       if (isNumericColumn) {
//         const cellStyle = {
//           font: { bold: true },
//           alignment: { horizontal: 'center' },
//           fill: {
//             fgColor: {
//               rgb: header.includes('Row Total') ? 'bbdefb' : 'e3f2fd',
//             },
//           },
//           border: {
//             left: { style: 'thin', color: { rgb: '000000' } },
//             top: { style: 'thin', color: { rgb: '000000' } },
//             right: { style: 'thin', color: { rgb: '000000' } },
//             bottom: { style: 'thin', color: { rgb: '000000' } },
//           },
//         };

//         let displayValue = total;
//         if (header.includes('Value') || header === 'Row Total Value') {
//           displayValue = total.toLocaleString('en-US', {
//             minimumFractionDigits: 2,
//             maximumFractionDigits: 2,
//           });
//         } else {
//           displayValue = total.toLocaleString();
//         }

//         ws[`${col}${totalRow}`] = {
//           v:
//             header.includes('Value') || header === 'Row Total Value'
//               ? parseFloat(displayValue.replace(/,/g, ''))
//               : displayValue,
//           t: 'n',
//           s: cellStyle,
//         };
//       } else if (header === 'Process Date' && (reportType === 'Day' || reportType === 'Production')) {
//         ws[`${col}${totalRow}`] = {
//           v: '',
//           t: 's',
//           s: {
//             fill: { fgColor: { rgb: 'e3f2fd' } },
//             border: {
//               left: { style: 'thin', color: { rgb: '000000' } },
//               top: { style: 'thin', color: { rgb: '000000' } },
//               right: { style: 'thin', color: { rgb: '000000' } },
//               bottom: { style: 'thin', color: { rgb: '000000' } },
//             },
//           },
//         };
//       }
//     }
//   });
// };
  
const addTotalRow = (ws, columns, dataLength, startRow) => {
  const totalRow = dataLength + startRow + 1;
  const headers = getExcelHeaders();

  ws[`A${totalRow}`] = {
    v: 'TOTAL',
    t: 's',
    s: {
      font: { bold: true },
      alignment: { horizontal: 'center' },
      fill: { fgColor: { rgb: 'e3f2fd' } },
      border: {
        left: { style: 'thin', color: { rgb: '000000' } },
        top: { style: 'thin', color: { rgb: '000000' } },
        right: { style: 'thin', color: { rgb: '000000' } },
        bottom: { style: 'thin', color: { rgb: '000000' } },
      },
    },
  };

  headers.forEach((header, colIndex) => {
    if (colIndex > 0) {
      const col = String.fromCharCode(65 + colIndex);
      let total = 0;

      // Skip non-numeric columns in total calculation
      const nonNumericColumns = ['Style Description', 'Style No', 'Process Date', 'Delivery Date'];
      if (nonNumericColumns.includes(header)) {
        // For non-numeric columns, add empty cell with styling
        ws[`${col}${totalRow}`] = {
          v: '',
          t: 's',
          s: {
            fill: { fgColor: { rgb: 'e3f2fd' } },
            border: {
              left: { style: 'thin', color: { rgb: '000000' } },
              top: { style: 'thin', color: { rgb: '000000' } },
              right: { style: 'thin', color: { rgb: '000000' } },
              bottom: { style: 'thin', color: { rgb: '000000' } },
            },
          },
        };
        return;
      }

      if (header === 'Order Qty') {
        // total = filteredData.reduce((sum, item) => sum + (parseFloat(item.OrderQty) || 0), 0);
        total = ''
      } else if (header.includes('Qty') && !header.includes('Value') && !header.includes('Row Total')) {
        total = filteredData.reduce((sum, item) => {
          let value = 0;
          if (reportType === 'Day') {
            value = item.processQuantity || 0;
          } else if (reportType === 'Style') {
            const processName = header.replace(' Qty', '');
            value = getProcessQuantity(item, processName) || 0;
          } else if (reportType === 'Production') {
            const processName = header.replace(' Qty', '');
            value = getProcessQuantity1(item, processName) || 0;
          }
          return sum + (parseFloat(value) || 0);
        }, 0);
      } else if (header.includes('Value') && !header.includes('Row Total')) {
        total = filteredData.reduce((sum, item) => {
          let value = 0;
          if (reportType === 'Production') {
            const processName = header.replace(' Value', '');
            const valueStr = getProcessValue(item, processName);
            value =
              typeof valueStr === 'string' ? parseFloat(valueStr.replace(/,/g, '')) || 0 : parseFloat(valueStr) || 0;
          }
          return sum + value;
        }, 0);
      }

      if (reportType === 'Production') {
        if (header === 'Row Total Qty') {
          total = filteredData.reduce((sum, item) => {
            let rowTotalQty = 0;
            if (selectedProcess.ProcessId === 0) {
              processOrder.forEach((processName) => {
                rowTotalQty += parseFloat(getProcessQuantity1(item, processName)) || 0;
              });
            } else {
              rowTotalQty = parseFloat(getProcessQuantity1(item, selectedProcess.ProcessName)) || 0;
            }
            return sum + rowTotalQty;
          }, 0);
        } else if (header === 'Row Total Value') {
          total = filteredData.reduce((sum, item) => {
            let rowTotalValue = 0;
            if (selectedProcess.ProcessId === 0) {
              processOrder.forEach((processName) => {
                const valueStr = getProcessValue(item, processName);
                const value =
                  typeof valueStr === 'string'
                    ? parseFloat(valueStr.replace(/,/g, '')) || 0
                    : parseFloat(valueStr) || 0;
                rowTotalValue += value;
              });
            } else {
              const valueStr = getProcessValue(item, selectedProcess.ProcessName);
              rowTotalValue =
                typeof valueStr === 'string'
                  ? parseFloat(valueStr.replace(/,/g, '')) || 0
                  : parseFloat(valueStr) || 0;
            }
            return sum + rowTotalValue;
          }, 0);
        }
      }

      const isNumericColumn =
        header.includes('Qty') ||
        header.includes('Value') ||
        header === 'Order Qty' ||
        header === 'Row Total Qty' ||
        header === 'Row Total Value';

      if (isNumericColumn) {
        const cellStyle = {
          font: { bold: true },
          alignment: { horizontal: 'center' },
          fill: {
            fgColor: {
              rgb: header.includes('Row Total') ? 'bbdefb' : 'e3f2fd',
            },
          },
          border: {
            left: { style: 'thin', color: { rgb: '000000' } },
            top: { style: 'thin', color: { rgb: '000000' } },
            right: { style: 'thin', color: { rgb: '000000' } },
            bottom: { style: 'thin', color: { rgb: '000000' } },
          },
        };

        let displayValue = total;
        if (header.includes('Value') || header === 'Row Total Value') {
          displayValue = total.toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          });
        } else {
          displayValue = total.toLocaleString();
        }

        ws[`${col}${totalRow}`] = {
          v:
            header.includes('Value') || header === 'Row Total Value'
              ? parseFloat(displayValue.replace(/,/g, ''))
              : displayValue,
          t: 'n',
          s: cellStyle,
        };
      } else if (header === 'Process Date' && (reportType === 'Day' || reportType === 'Production')) {
        ws[`${col}${totalRow}`] = {
          v: '',
          t: 's',
          s: {
            fill: { fgColor: { rgb: 'e3f2fd' } },
            border: {
              left: { style: 'thin', color: { rgb: '000000' } },
              top: { style: 'thin', color: { rgb: '000000' } },
              right: { style: 'thin', color: { rgb: '000000' } },
              bottom: { style: 'thin', color: { rgb: '000000' } },
            },
          },
        };
      }
    }
  });
};
const getProcessOrder = async () => {
    try {
      const res = await axios.instance.get('/GetProcessOrder', {
        headers: { Authorization: token, 'Content-Type': 'application/json' },
      });
      const orderedProcessNames = res.data.map((process) => process.ProcessName);
      setProcessOrder(orderedProcessNames);
    } catch (error) {
      console.error('Error fetching process order:', error);
      setProcessOrder(['Cutting', 'Production', 'Ironing', 'Finishing', 'Packing', 'Shipping']);
    }
  };

  // STYLE -----------START HERE-----------------

  // Define your desired order
  // const processOrder = ['Cutting', 'Production', 'Ironing', 'Finishing', 'Packing', 'Shipping'];

  // Function to get quantity for a specific process
  // const getProcessQuantity = (data, processName) => {
  //   const quantityMap = {
  //     Cutting: data.Cutting,
  //     Production: obProduction ? data.DailyProduction : data.Production,
  //     Ironing: data.Ironing,
  //     Finishing: data.Finishing,
  //     Packing: data.Packing,
  //     Shipping: data.Shipping, // Added Shipping
  //   };

  //   return quantityMap[processName] || 0;
  // };

  const getProcessQuantity = (data, processName) => {
    // Create a dynamic mapping based on process names
    const quantityMap = {};

    // For each process in processOrder, map to the corresponding data field
    processOrder.forEach((process) => {
      // Convert process name to the expected field name in data
      // Example: "Cutting" -> "Cutting", "Production" -> obProduction ? "DailyProduction" : "Production"
      if (process === 'Production') {
        quantityMap[process] = obProduction ? data.DailyProduction : data.Production;
      } else {
        // For other processes, use the process name directly
        quantityMap[process] = data[process];
      }
    });

    return quantityMap[processName] || 0;
  };

  // STYLE -----------END HERE ---------------------------

  // Production -----------START HERE-----------------

  // const getProcessQuantity1 = (enquiry, processName) => {
  //   const quantityMap = {
  //     Cutting: enquiry.CuttingQty,
  //     Production: obProduction ? enquiry.DailyProductionQty : enquiry.ProductionQty,
  //     Ironing: enquiry.IroningQty,
  //     Finishing: enquiry.FinishingQty,
  //     Packing: enquiry.PackingQty,
  //     Shipping: enquiry.ShippingQty, // Added Shipping
  //   };

  //   return quantityMap[processName] || 0;
  // };

  // const getProcessValue = (enquiry, processName) => {
  //   const valueMap = {
  //     Cutting: enquiry.CuttingVal,
  //     Production: obProduction ? enquiry.DailyProductionVal : enquiry.ProductionVal,
  //     Ironing: enquiry.IroningVal,
  //     Finishing: enquiry.FinishingVal,
  //     Packing: enquiry.PackingVal,
  //     Shipping: enquiry.ShippingVal, // Added Shipping
  //   };

  //   const value = valueMap[processName] || 0;
  //   return typeof value === 'number'
  //     ? value.toLocaleString('en-US', {
  //         minimumFractionDigits: 2,
  //         maximumFractionDigits: 2,
  //       })
  //     : '0.00';
  // };

  const getProcessQuantity1 = (enquiry, processName) => {
    const quantityMap = {};

    processOrder.forEach((process) => {
      if (process === 'Production') {
        quantityMap[process] = obProduction ? enquiry.DailyProductionQty : enquiry.ProductionQty;
      } else {
        // Add 'Qty' suffix for quantity fields
        quantityMap[process] = enquiry[`${process}Qty`];
      }
    });

    return quantityMap[processName] || 0;
  };

  const getProcessValue = (enquiry, processName) => {
    const valueMap = {};

    processOrder.forEach((process) => {
      if (process === 'Production') {
        valueMap[process] = obProduction ? enquiry.DailyProductionVal : enquiry.ProductionVal;
      } else {
        // Add 'Val' suffix for value fields
        valueMap[process] = enquiry[`${process}Val`];
      }
    });

    const value = valueMap[processName] || 0;
    return typeof value === 'number'
      ? value.toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      : '0.00';
  };


const getEmployeeSalaryTrack = async (overrides = {}) => {
    const effectiveFromDate = overrides.fromDate ?? fromDate;
    const effectiveToDate = overrides.toDate ?? toDate;
    const effectiveStyleSelected = overrides.styleSelected ?? styleSelected;
    const effectiveStyleNumberSelected = overrides.styleNumberSelected ?? styleNumberSelected;
    const effectiveSelectedProcess = overrides.selectedProcess ?? selectedProcess;
  try {
    const res = await axios.instance.post(
      `/GetEmployeeSalaryTrack`,
      {
       FromDate: effectiveFromDate,
          ToDate: effectiveToDate,
          StyleDescription: effectiveStyleSelected.StyleDescription,
          StyleNumber: effectiveStyleNumberSelected.StyleNumber,
          processId: effectiveSelectedProcess.ProcessId,
      },
      {
        headers: {
          Authorization: token,
          'Content-Type': 'application/json'
        },
      }
    );

    return res.data;  

  } catch (error) {
    console.error('Error fetching data:', error);
    return [];
  }
};

const handleTotalClick = async (processName) => {
  console.log("Process Name:", processName);
  try {
    setOpenLoader(true);

    const data = await getEmployeeSalaryTrack();
    console.log("API DATA:", data);

    let filtered = data;

    if (processName) {
      filtered = data.filter(
        item => (item.ProcessDescription).toLowerCase().trim() === (processName).toLowerCase().trim()
      );
    }
    console.log("Filtered Data:", filtered);

    const formatted = filtered.map(item => ({
      date: item.WorkDate,
      employeeName: item.UserName,
      employeeCode: item.UserCode,
      salary: item.Salary,
      perDaySalary: item.perdaySal,
      process: item.ProcessDescription,
      designation : item.DesignationDescription
    }));

    setdetailsData(formatted);
    setOpen(true);  
    setOpenLoader(false);

  } catch (error) {
    console.error(error);
    setOpenLoader(false);
  }
};

const groupedData = detailsData.reduce((acc, item) => {
  const date = moment(item.date).format('DD-MM-YYYY');

  if (!acc[date]) {
    acc[date] = [];
  }

  acc[date].push(item);

  return acc;
}, {});


const grandTotal = detailsData.reduce(
  (sum, i) => sum + Number(i.perDaySalary),
  0
);

  // Production -------------------------END HERE -----------------

  return (
    <>
      <Container maxWidth={'xl'} sx={{ pt: 2, p: 1 }} elevation={3}>
        <Snackbar
          style={{ marginTop: '45px' }}
          open={showNoResultsSnackbar}
          autoHideDuration={4000}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          onClose={handleCloseSnackbar}
        >
          <Alert onClose={handleCloseSnackbar} severity="info" variant="filled" sx={{ width: '100%' }}>
            {noResultsMessage}
          </Alert>
        </Snackbar>

        <Grid justifyContent={'space-between'} alignItems={'center'} spacing={2} mb={2}>
          <Typography
            variant="h5"
            p={1}
            boxShadow={1}
            borderColor="#11235A"
            textAlign={'center'}
            borderRadius={2}
            pl={2}
            color="white"
            sx={{
              background: 'linear-gradient(to right, #134e5e, #71b280)',
              boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px',
            }}
          >
            <Typography variant="h6" color="white" className="font_style1" textAlign={'center'}>
              Process Tracker Report
            </Typography>
          </Typography>
        </Grid>

        {/* filters */}
        <Stack sx={{ border: '1px solid #CDE8E5', borderRadius: 4, my: 2 }}>
          <Accordion
            expanded={expanded}
            onChange={handleExpansion}
            disableGutters
            sx={{ borderTop: 'none', borderColor: 'black', backgroundColor: 'inherit' }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon style={{ color: '#36BA98' }} />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              sx={{ borderTop: 'none' }}
            >
              <Stack justifyContent={'start'} direction={'row'} alignItems={'center'} p={0} m={0}>
                <IconButton aria-label="ExpandMoreIcon" color="white">
                  <MastersIcon style={{ color: 'white', width: 24, height: 24 }} />
                </IconButton>
                <Typography
                  sx={{
                    color: '#36BA98',
                    '&.active': {
                      color: 'text.primary',
                      bgcolor: 'action.selected',
                      fontWeight: 'fontWeightBold',
                    },
                  }}
                  variant="h6"
                >
                  Filters
                </Typography>
              </Stack>
            </AccordionSummary>

            <AccordionDetails sx={{ borderTop: 'none', py: 0, pb: 2, pl: 3 }}>
              <Stack direction={'column'} justifyContent={'space-between'} spacing={2} my={1}>
                <Stack direction={{ sm: 'row', xs: 'column' }} spacing={1}>
                  <Grid container spacing={2} rowSpacing={2} columnSpacing={2}>
                    <Grid item xs={12}>
                      <Stack direction={'row'} justifyContent={'end'} spacing={2}>
                        <FormControl size="small" component="fieldset">
                          <Stack direction={'row'} justifyContent={'center'} alignItems={'center'} spacing={2}>
                            <RadioGroup
                              row
                              value={reportType}
                              onChange={(e) => {
                                setReportType(e.target.value);
                                resetFilters(e.target.value);
                                setStyleSelected({
                                  Srhid: '0',
                                  StyleDescription: 'All',
                                });
                                 setStyleNumberSelected({
                                  Srhid: '0',
                                  StyleNumber: 'All',
                                });
                              }}
                            >
                              <FormControlLabel value="Day" control={<Radio />} label="Process Wise" />
                              <FormControlLabel value="Style" control={<Radio />} label="Style Wise" />
                              <FormControlLabel value="Production" control={<Radio />} label="Process Status" />
                            </RadioGroup>
                          </Stack>
                        </FormControl>
                      </Stack>
                    </Grid>
                   <Grid item xs={12} sm={4}>
  <FormControl fullWidth size="small" required={reportType === 'Day'}>
    <InputLabel>Select Process</InputLabel>
    
    {/* For Production report - Multi-select with checkboxes */}
    {reportType === 'Production' ? (
      <Select
        multiple
        value={selectedProcessIds}
        onChange={handleProcessMultiChange}
        label="Select Process"
        renderValue={(selected) => {
          if (selected.length === 0 || (selected.length === processData.length && isAllProcessesSelected)) {
            return 'All';
          }
          return selectedProcessNames.join(', ');
        }}
        MenuProps={{
          PaperProps: {
            style: {
              maxHeight: 300,
            },
          },
        }}
      >
        <MenuItem value="all">
          <Checkbox checked={isAllProcessesSelected} />
          <ListItemText primary="All" />
        </MenuItem>
        {processData.map((process) => (
          <MenuItem key={process.ProcessId} value={process.ProcessId.toString()}>
            <Checkbox checked={selectedProcessIds.includes(process.ProcessId.toString())} />
            <ListItemText primary={process.ProcessName} />
          </MenuItem>
        ))}
      </Select>
    ) : (
      /* For Day and Style reports - Single select dropdown */
      <Select
        value={reportType === 'Day' ? selectedProcess.ProcessId : (selectedProcess.ProcessId || '0')}
        onChange={handleProcessChange}
        label="Select Process"
      >
        {(reportType === 'Style') && (
          <MenuItem value="0">All</MenuItem>
        )}
        {processData.map((process) => (
          <MenuItem key={process.ProcessId} value={process.ProcessId.toString()}>
            {process.ProcessName}
          </MenuItem>
        ))}
      </Select>
    )}
  </FormControl>
</Grid>
                    <Grid item xs={12} md={4}>
                     <FormControl size="small" fullWidth component="fieldset">
  <Autocomplete
    size="small"
    fullWidth
    options={[{ Srhid: '0', StyleDescription: 'All' }, ...styleDesc]}
    getOptionLabel={(obj) => {
      if (!obj) return '';
      if (obj.Srhid === '0') return 'All';

      const style = obj.StyleDescription || '';
      const styleNo = obj.StyleNumber || '';
      const ob = obj.ObNo || obj.ObRef || '';
      const ts = obj.TsNo || '';

      const tsPart = ts && ts !== '0' ? ` (TS# ${ts})` : '';
      return `${style} `;
    }}
    isOptionEqualToValue={(option, value) => option.Srhid === value.Srhid}
    renderInput={(params) => <TextField {...params} label="Style Description" />}
    value={styleSelected}
    onChange={handleStyleDescriptionChange}
    clearText="Clear"
  />
</FormControl>
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <FormControl size="small" fullWidth component="fieldset">
  <Autocomplete
    size="small"
    fullWidth
    options={[
      { Srhid: '0', StyleNumber: 'All' },
      ...(styleSelected.Srhid === '0' ? styleData : filteredStyleNumbers)
    ]}
    getOptionLabel={(obj) => {
      if (!obj) return '';
      if (obj.Srhid === '0') {
        return 'All';
      }
      return obj.StyleNumber || '';
    }}
    isOptionEqualToValue={(option, value) => option.Srhid === value.Srhid}
    renderInput={(params) => <TextField {...params} label="Style Number" />}
    value={styleNumberSelected}
    onChange={handleStyleNumberChange}
    disabled={styleNumberVisible}
    clearText="Clear"
  />
</FormControl>
                    </Grid>

                    {(reportType === 'Day' || reportType === 'Production') && (
                      <Grid item xs={12} md={3} lg={3}>
                        <TextField
                          fullWidth
                          size="small"
                          label="From Date"
                          type="date"
                          value={fromDate}
                          min={'1000-01-01'}
                          max={'9999-12-31'}
                          onChange={(e) => {
                            if (e.target.value) setFromDate(e.target.value);
                          }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </Grid>
                    )}
                    <Grid item xs={12} md={3} lg={reportType === 'Style' ? 3 : 3}>
                      <TextField
                        fullWidth
                        size="small"
                        label={`${reportType === 'Style' ? 'As On Date' : 'To Date'}`}
                        type="date"
                        value={toDate}
                        min={'1000-01-01'}
                        max={'9999-12-31'}
                        onChange={(e) => {
                          if (e.target.value) setToDate(e.target.value);
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </Grid>
                     <Grid item xs={12} md={3}>
                         <SwitchContainer>
                                                <input
                                                  id={`summary`}
                                                   className="checkboxfilter"
                                                  type="checkbox"
                                                  checked={summary}
                                                  disabled={summaryVisible}
                                                  onClick={(e) => {
                                                    // const newValue = !overall;
                                                    setSummary(!summary);
                                                    handlehidevisible()
                                                    
                                                    setFilteredData([]);
                                                  }}
                                                />{' '}
                                                <Label
                                                  htmlFor='summary'
                                                  className=" font_stylechecklable text-dark-emphasis"
                                                  style={{ color: '#468585' }}
                                                >
                                                  Summary
                                                </Label>
                                              </SwitchContainer>
                                              </Grid>

                    <Grid item xs={12} md={12}>
                      <Stack direction={{ xs: 'row' }} spacing={1} justifyContent={'end'}>
                        <Stack direction={'row'} spacing={1}>
                          <Button
                            variant="contained"
                            color="secondary"
                            onClick={() => applyFilters()}
                            startIcon={<FilterAltIcon />}
                            sx={{ boxShadow: 0 }}
                          >
                            Apply Filters
                          </Button>
                          <Button
                            variant="contained"
                            color="warning"
                            onClick={() => resetFilters(reportType)}
                            startIcon={<LockResetIcon />}
                            sx={{ boxShadow: 0 }}
                          >
                            reset
                          </Button>
                          <Button
                            variant="contained"
                            color="success"
                            onClick={exportToExcel}
                            startIcon={<DownloadIcon />}
                            sx={{ boxShadow: 0 }}
                            disabled={filteredData.length === 0}
                          >
                            Export Excel
                          </Button>
                        </Stack>
                      </Stack>
                    </Grid>
                  </Grid>
                </Stack>
              </Stack>
            </AccordionDetails>
          </Accordion>
        </Stack>

        <Collapse in={filteredData.length > 0}>
          <>
            {reportType === 'Day' && (
              <TableContainer sx={{ borderRadius: 1, backgroundColor: 'inherit' }} elevation={4} component={Paper}>
                <Table size="small">
                  <TableHead>
                    <TableRow sx={{ padding: 'none' }}>
                      <StyledTableCell align="center">SNo</StyledTableCell>
                     {!summary && <StyledTableCell align="center">Process Date</StyledTableCell>}
                      <StyledTableCell align="center">Style Description</StyledTableCell>
                      {!summary && <StyledTableCell align="center">Style No</StyledTableCell>}
                      <StyledTableCell align="right">Order Qty</StyledTableCell>
                      <StyledTableCell align="right">{selectedProcess.ProcessName} Qty</StyledTableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {(rowsPerPage > 0
                      ? filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      : filteredData
                    ).map((enq, index) => (
                      <TableRow key={index} hover>
                        <TableCell align="center" padding="normal">
                          {' '}
                          {index + 1}{' '}
                        </TableCell>
                        {!summary && <TableCell align="center" padding="normal">
                          {' '}
                          {moment(enq.ProcessDate).format('DD-MM-YYYY')}{' '}
                        </TableCell>}
                        <TableCell align="center" padding="normal">
                          {' '}
                          {enq.StyleDescription}{' '}
                        </TableCell>
                       {!summary &&  <TableCell align="center" padding="normal">
                          {' '}
                          {enq.StyleNumber}{' '}
                        </TableCell> }
                        <TableCell align="right" padding="normal">
                          {' '}
                          {enq.OrderQty}{' '}
                        </TableCell>
                        <TableCell align="right" padding="normal">
                          {' '}
                          {enq.processQuantity}{' '}
                        </TableCell>
                      </TableRow>
                    ))}
                           {filteredData.length > 0 && (
                      <TableRow sx={{ backgroundColor: '#e3f2fd' }}>
                        <TableCell align="center" colSpan={!summary ? 5 : 3} sx={{ fontWeight: 'bold' }}>
                          TOTAL
                        </TableCell>
                        {/* <TableCell align="right" sx={{ fontWeight: 'bold' }}>
                          {filteredData.reduce((sum, item) => sum + (parseFloat(item.OrderQty) || 0), 0).toLocaleString()}
                        </TableCell> */}
                        <TableCell align="right" sx={{ fontWeight: 'bold' }}>
                          {filteredData
                            .reduce((sum, item) => sum + (parseFloat(item.processQuantity) || 0), 0)
                            .toLocaleString()}
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            )}

            {reportType === 'Style' && (
              <TableContainer sx={{ borderRadius: 1, backgroundColor: 'inherit' }} elevation={4} component={Paper}>
                <Table size="small">
                  <TableHead>
                    <TableRow sx={{ padding: 'none' }}>
                      <StyledTableCell align="center">SNo</StyledTableCell>
                      <StyledTableCell align="center">Image</StyledTableCell>
                      <StyledTableCell align="center">Style Description</StyledTableCell>
                    {!summary &&  <StyledTableCell align="center">Style No</StyledTableCell>}
                     <StyledTableCell align="center">Delivery Date</StyledTableCell>
                      <StyledTableCell align="right">Order Qty</StyledTableCell>
                      {/* Dynamic Process Headers */}
                      {selectedProcess.ProcessId === 0 ? (
                        // Show all process columns in specific order
                        processOrder.map((processName) => (
                          <StyledTableCell key={processName} align="center">
                            {processName} Qty
                          </StyledTableCell>
                        ))
                      ) : (
                        // Show only selected process column
                        <StyledTableCell align="right">{selectedProcess.ProcessName} Qty</StyledTableCell>
                      )}
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {(rowsPerPage > 0
                      ? filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      : filteredData
                    ).map((enq, index) => (
                      <TableRow key={index} hover>
                        <TableCell align="center" padding="normal">
                          {' '}
                          {index + 1}{' '}
                        </TableCell>
   <TableCell align="center" padding="normal">
  <IconButton
    onClick={() => {
      if (enq.OBImage) {
        setSelectedImage(`${axios.baseURL}OperationBulletin/${enq.OBImage}`);
        setSelectedImageStyle({
          StyleDescription: enq.StyleDescription,
          StyleNumber: enq.StyleNumber
        });
        setImagePreviewOpen(true);
      }
    }}
    disabled={!enq.OBImage}
    sx={{
      padding: 0,
      borderRadius: 1,
      overflow: 'hidden',
      '&:hover': enq.OBImage ? {
        transform: 'scale(1.05)',
        boxShadow: '0 0 8px rgba(0,0,0,0.3)',
        backgroundColor: 'transparent'
      } : {}
    }}
  >
    <img
      src={
        enq.OBImage
          ? `${axios.baseURL}OperationBulletin/${enq.OBImage}`
          : `${NoimageFound}`
      }
      alt={enq.OBImage ? "View Operation Bulletin Image" : "No Image Available"}
      style={{
        maxWidth: '50px',
        maxHeight: '100px',
        objectFit: 'contain',
        cursor: enq.OBImage ? 'pointer' : 'default',
        transition: 'transform 0.2s ease',
      }}
    />
  </IconButton>
</TableCell>
                        <TableCell align="center" padding="normal">
                          {' '}
                          {enq.StyleDescription}{' '}
                        </TableCell>
                        {!summary &&  <TableCell align="center" padding="normal">
                          {' '}
                          {enq.StyleNumber}{' '}
                        </TableCell>}
                       <TableCell align="center" padding="normal">
                          {' '}
                         {enq.DeliveryDate ? moment(enq.DeliveryDate).format('DD-MM-YYYY') : ''}{' '}
                        </TableCell>
                        <TableCell align="right" padding="normal">
                          {' '}
                          {enq.OrderQty}{' '}
                        </TableCell>

                        {/* Dynamic Process Quantity Cells */}
                        {selectedProcess.ProcessId === 0 ? (
                          // Show quantities for all processes in specific order
                          processOrder.map((processName) => (
                            <TableCell key={processName} align="right" padding="normal">
                              {getProcessQuantity(enq, processName) || 0}
                            </TableCell>
                          ))
                        ) : (
                          // Show quantity only for selected process
                          <TableCell align="right" padding="normal">
                            {getProcessQuantity(enq, selectedProcess.ProcessName) || 0}
                          </TableCell>
                        )}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            )}

           {reportType === 'Production' && (
  <TableContainer sx={{ borderRadius: 1, backgroundColor: 'inherit' }} elevation={4} component={Paper}>
    <Table size="small">
      <TableHead>
        {/* First header row - Main headers */}
        <TableRow sx={{ padding: 'none' }}>
          <StyledTableCell align="center" rowSpan={2}>
            SNo
          </StyledTableCell>
          {summary && <StyledTableCell align="center" rowSpan={2}>
            Image
          </StyledTableCell>}
          {!summary && <StyledTableCell align="center" rowSpan={2}>
            Process Date
          </StyledTableCell>}
          <StyledTableCell align="center" rowSpan={2}>
            Style Description
          </StyledTableCell>
          {!summary && <StyledTableCell align="center" rowSpan={2}>
            Style Number
          </StyledTableCell>}
          {summary && <StyledTableCell align="center" rowSpan={2}>Delivery Date</StyledTableCell>}
          <StyledTableCell align="right" rowSpan={2}>
            Order Qty
          </StyledTableCell>

          {/* Dynamic Process Headers with colSpan={2} - UPDATED FOR MULTI-SELECT */}
          {isAllProcessesSelected ? (
            // Show ALL process columns when "All" is selected
            processOrder.map((processName) => (
              <StyledTableCell key={processName} align="center" colSpan={2}>
                {processName}
              </StyledTableCell>
            ))
          ) : selectedProcessIds.length > 0 ? (
            // Show ONLY selected processes
            selectedProcessNames.map((processName) => (
              <StyledTableCell key={processName} align="center" colSpan={2}>
                {processName}
              </StyledTableCell>
            ))
          ) : (
            // No processes selected - show placeholder
            <StyledTableCell align="center" colSpan={2}>
              No Process Selected
            </StyledTableCell>
          )}

          {/* Row Total Headers - Only show if processes are selected */}
          {(isAllProcessesSelected || selectedProcessIds.length > 0) && (
            <StyledTableCell align="center" rowSpan={2}>
              Total Value
            </StyledTableCell>
          )}
        </TableRow>

        {/* Second header row - Sub headers (Qty, Value) - UPDATED FOR MULTI-SELECT */}
        <TableRow sx={{ padding: 'none' }}>
          {/* Dynamic Qty/Value Headers */}
          {isAllProcessesSelected ? (
            // Show Qty/Value for ALL processes
            processOrder.map((processName) => (
              <React.Fragment key={processName}>
                <StyledTableCell align="center">Qty</StyledTableCell>
                <StyledTableCell align="center">Value</StyledTableCell>
              </React.Fragment>
            ))
          ) : selectedProcessIds.length > 0 ? (
            // Show Qty/Value for SELECTED processes only
            selectedProcessNames.map((processName) => (
              <React.Fragment key={processName}>
                <StyledTableCell align="center">Qty</StyledTableCell>
                <StyledTableCell align="center">Value</StyledTableCell>
              </React.Fragment>
            ))
          ) : (
            <StyledTableCell align="center">No Data</StyledTableCell>
          )}
        </TableRow>
      </TableHead>

      <TableBody>
        {/* Data rows */}
        {(rowsPerPage > 0
          ? filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          : filteredData
        ).map((enq, index) => {
          // Calculate row totals for this entry - UPDATED FOR MULTI-SELECT
          let rowTotalValue = 0;

          if (isAllProcessesSelected) {
            // Calculate totals across ALL processes
            processOrder.forEach((processName) => {
              const valueStr = getProcessValue(enq, processName);
              const value = typeof valueStr === 'string'
                ? parseFloat(valueStr.replace(/,/g, '')) || 0
                : parseFloat(valueStr) || 0;
              rowTotalValue += value;
            });
          } else if (selectedProcessIds.length > 0) {
            // Calculate totals for SELECTED processes only
            selectedProcessNames.forEach((processName) => {
              const valueStr = getProcessValue(enq, processName);
              const value = typeof valueStr === 'string'
                ? parseFloat(valueStr.replace(/,/g, '')) || 0
                : parseFloat(valueStr) || 0;
              rowTotalValue += value;
            });
          }

          return (
            <TableRow key={index} hover>
              <TableCell align="center" padding="normal">
                {index + 1}
              </TableCell>
              {summary && <TableCell align="center" padding="normal">
                <IconButton
                  onClick={() => {
                    if (enq.OBImage) {
                      setSelectedImage(`${axios.baseURL}OperationBulletin/${enq.OBImage}`);
                      setSelectedImageStyle({
                        StyleDescription: enq.StyleDescription,
                        StyleNumber: enq.StyleNumber
                      });
                      setImagePreviewOpen(true);
                    }
                  }}
                  disabled={!enq.OBImage}
                  sx={{
                    padding: 0,
                    borderRadius: 1,
                    overflow: 'hidden',
                    '&:hover': enq.OBImage ? {
                      transform: 'scale(1.05)',
                      boxShadow: '0 0 8px rgba(0,0,0,0.3)',
                      backgroundColor: 'transparent'
                    } : {}
                  }}
                >
                  <img
                    src={enq.OBImage ? `${axios.baseURL}OperationBulletin/${enq.OBImage}` : `${NoimageFound}`}
                    alt={enq.OBImage ? "View Operation Bulletin Image" : "No Image Available"}
                    style={{
                      maxWidth: '50px',
                      maxHeight: '100px',
                      objectFit: 'contain',
                      cursor: enq.OBImage ? 'pointer' : 'default',
                      transition: 'transform 0.2s ease',
                    }}
                  />
                </IconButton>
              </TableCell>}
              {!summary && <TableCell align="center" padding="normal">
                {moment(enq.ProcessDate).format('DD-MM-YYYY')}
              </TableCell>}
              <TableCell align="center" padding="normal">
                {enq.StyleDescription}
              </TableCell>
              {!summary && <TableCell align="center" padding="normal">
                {enq.StyleNumber}
              </TableCell>}
              {summary && <TableCell align="center" padding="normal">
                {enq.DeliveryDate ? moment(enq.DeliveryDate).format('DD-MM-YYYY') : ''}
              </TableCell>}
              <TableCell align="right" padding="normal">
                {enq.OrderQty}
              </TableCell>

              {/* Dynamic Process Quantity and Value Cells - UPDATED FOR MULTI-SELECT */}
              {isAllProcessesSelected ? (
                // Show ALL processes
                processOrder.map((processName) => (
                  <React.Fragment key={processName}>
                    <TableCell align="right" padding="normal">
                      {getProcessQuantity1(enq, processName) || 0}
                    </TableCell>
                    <TableCell align="right" padding="normal">
                      {getProcessValue(enq, processName) || '0.00'}
                    </TableCell>
                  </React.Fragment>
                ))
              ) : selectedProcessIds.length > 0 ? (
                // Show ONLY selected processes
                selectedProcessNames.map((processName) => (
                  <React.Fragment key={processName}>
                    <TableCell align="right" padding="normal">
                      {getProcessQuantity1(enq, processName) || 0}
                    </TableCell>
                    <TableCell align="right" padding="normal">
                      {getProcessValue(enq, processName) || '0.00'}
                    </TableCell>
                  </React.Fragment>
                ))
              ) : null}

              {/* Row Total Cells */}
              {(isAllProcessesSelected || selectedProcessIds.length > 0) && (
                <TableCell
                  align="right"
                  padding="normal"
                  sx={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}
                >
                  {rowTotalValue.toLocaleString('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </TableCell>
              )}
            </TableRow>
          );
        })}

        {/* Column Totals Row - UPDATED FOR MULTI-SELECT */}
        {filteredData.length > 0 && (isAllProcessesSelected || selectedProcessIds.length > 0) && (
          <TableRow sx={{ backgroundColor: '#e3f2fd' }}>
            <TableCell align="center" colSpan={(() => {
              let baseCols = 1; // SNo
              if (summary) baseCols += 1; // Image
              if (!summary) baseCols += 1; // Process Date
              baseCols += 1; // Style Description
              if (!summary) baseCols += 1; // Style Number
              if (summary) baseCols += 1; // Delivery Date
              baseCols += 1; // Order Qty
              return baseCols;
            })()} sx={{ fontWeight: 'bold' }}>
              TOTAL
            </TableCell>

            {isAllProcessesSelected ? (
              // Column totals for ALL processes
              processOrder.flatMap((processName) => {
                const totalQty = filteredData.reduce((sum, enq) => {
                  return sum + (parseFloat(getProcessQuantity1(enq, processName)) || 0);
                }, 0);

                const totalValue = filteredData.reduce((sum, enq) => {
                  const value = getProcessValue(enq, processName);
                  const numValue = typeof value === 'string'
                    ? parseFloat(value.replace(/,/g, '')) || 0
                    : parseFloat(value) || 0;
                  return sum + numValue;
                }, 0);

                return [
                  <TableCell key={`${processName}-qty-total`} align="right" sx={{ fontWeight: 'bold' }}>
                    {totalQty.toLocaleString()}
                  </TableCell>,
                  <TableCell 
                    key={`${processName}-value-total`} 
                    align="right" 
                    sx={{ fontWeight: 'bold', color: '#2e7d32', cursor: 'pointer'}}
                    onClick={() => handleTotalClick(processName)}
                  >
                    {totalValue.toLocaleString('en-US', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </TableCell>,
                ];
              })
            ) : selectedProcessIds.length > 0 ? (
              // Column totals for SELECTED processes only
              selectedProcessNames.flatMap((processName) => {
                const totalQty = filteredData.reduce((sum, enq) => {
                  return sum + (parseFloat(getProcessQuantity1(enq, processName)) || 0);
                }, 0);

                const totalValue = filteredData.reduce((sum, enq) => {
                  const value = getProcessValue(enq, processName);
                  const numValue = typeof value === 'string'
                    ? parseFloat(value.replace(/,/g, '')) || 0
                    : parseFloat(value) || 0;
                  return sum + numValue;
                }, 0);

                return [
                  <TableCell key={`${processName}-qty-total`} align="right" sx={{ fontWeight: 'bold' }}>
                    {totalQty.toLocaleString()}
                  </TableCell>,
                  <TableCell 
                    key={`${processName}-value-total`} 
                    align="right" 
                    sx={{ fontWeight: 'bold', color: '#2e7d32', cursor: 'pointer'}}
                    onClick={() => handleTotalClick(processName)}
                  >
                    {totalValue.toLocaleString('en-US', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </TableCell>,
                ];
              })
            ) : null}

            {/* Grand Total Cell */}
            {(isAllProcessesSelected || selectedProcessIds.length > 0) && (
              <TableCell align="right" sx={{ fontWeight: 'bold', backgroundColor: '#bbdefb' }}>
                {filteredData
                  .reduce((total, enq) => {
                    let rowValueTotal = 0;
                    if (isAllProcessesSelected) {
                      processOrder.forEach((processName) => {
                        const valueStr = getProcessValue(enq, processName);
                        const value = typeof valueStr === 'string'
                          ? parseFloat(valueStr.replace(/,/g, '')) || 0
                          : parseFloat(valueStr) || 0;
                        rowValueTotal += value;
                      });
                    } else if (selectedProcessIds.length > 0) {
                      selectedProcessNames.forEach((processName) => {
                        const valueStr = getProcessValue(enq, processName);
                        const value = typeof valueStr === 'string'
                          ? parseFloat(valueStr.replace(/,/g, '')) || 0
                          : parseFloat(valueStr) || 0;
                        rowValueTotal += value;
                      });
                    }
                    return total + rowValueTotal;
                  }, 0)
                  .toLocaleString('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
              </TableCell>
            )}
          </TableRow>
        )}
      </TableBody>
    </Table>
  </TableContainer>
)}

            {/* pagination */}
            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={totalRows}
              rowsPerPage={rowsPerPage}
              page={currentPage} // Use the calculated currentPage value
              onPageChange={(event, newPage) => setPage(newPage)}
              onRowsPerPageChange={(event) => {
                setRowsPerPage(parseInt(event.target.value, 10));
                setPage(0); // Reset the page when rowsPerPage changes
              }}
              mt={2}
            />
          </>
        </Collapse>

        {isFromDashboard && (
          <Stack direction="row" justifyContent="flex-start" sx={{ mt: 2.5, mb: 1 }}>
            <Button
              variant="contained"
              startIcon={<ArrowBackRoundedIcon />}
              onClick={() => navigate('/dashboard/home')}
              sx={{
                px: 2,
                py: 0.75,
                minHeight: 40,
                borderRadius: 999,
                fontWeight: 800,
                letterSpacing: 0.2,
                textTransform: 'none',
                color: '#f5fbff',
                background: 'linear-gradient(135deg, #0f4c75 0%, #1b6ca8 100%)',
                boxShadow: '0 10px 22px rgba(15, 76, 117, 0.18)',
                '&:hover': {
                  background: 'linear-gradient(135deg, #0d4264 0%, #15598c 100%)',
                  boxShadow: '0 12px 24px rgba(15, 76, 117, 0.24)',
                },
              }}
            >
              Back to Dashboard
            </Button>
          </Stack>
        )}
      </Container>

      {/* loader popup dialog box */}
      <Dialog
        open={openLoader}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        <LinearProgress />
      </Dialog>

<Dialog
  open={imagePreviewOpen}
  onClose={() => setImagePreviewOpen(false)}
  maxWidth="sm"
  fullWidth
  PaperProps={{
    sx: {
      maxHeight: '85vh',
    }
  }}
>
  {/* Header - Compact layout */}
  <DialogTitle sx={{ 
    backgroundColor: '#219C90', 
    color: 'white',
    padding: '8px 16px',
    marginBottom: '5px',
    position: 'relative',
    display: 'block', // Changed to block for natural height
  }}>
    {/* Content area */}
    <Box sx={{ 
      pr: 4, // Leave space for the close button
    }}>
      <Typography variant="subtitle1" fontWeight="bold" noWrap>
        {selectedImageStyle.StyleDescription || 'Image Preview'}
      </Typography>
      {selectedImageStyle.StyleNumber && (
        <Typography variant="caption" sx={{ opacity: 0.9, display: 'block', mt: 0.25 }}>
          Style Number: {selectedImageStyle.StyleNumber}
        </Typography>
      )}
    </Box>
    
    {/* Close button - Top right corner */}
    <IconButton
      aria-label="close"
      onClick={() => setImagePreviewOpen(false)}
      sx={{
        position: 'absolute',
        right: 8,
        top: 8,
        color: 'white',
        padding: '4px',
      }}
      size="small"
    >
      <CloseIcon fontSize="small" />
    </IconButton>
  </DialogTitle>

  {/* Image Content */}
  <DialogContent sx={{ 
    padding: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'visible',
  }}>
    {selectedImage ? (
      <Box sx={{
        width: '100%',
        padding: 0.5,
      }}>
        <img
          src={selectedImage}
          alt="Operation Bulletin"
          style={{ 
            width: '100%',
            height: 'auto',
            maxHeight: '60vh',
            objectFit: 'contain',
            display: 'block',
          }}
        />
        
        {selectedImage.includes('noimage.jpg') && (
          <Typography 
            variant="caption" 
            color="textSecondary" 
            sx={{ 
              fontStyle: 'italic',
              textAlign: 'center',
              display: 'block',
              mt: 0.5,
            }}
          >
            No operation bulletin image available
          </Typography>
        )}
      </Box>
    ) : (
      <Typography 
        variant="body2" 
        color="textSecondary" 
        align="center"
      >
        No image to display
      </Typography>
    )}
  </DialogContent>
</Dialog>

<Dialog
  open={open}
  onClose={() => setOpen(false)}
  fullWidth
  maxWidth="md"    
  hideBackdrop={minimized}
  PaperProps={{
    sx: {
      borderRadius: 3,
      height: minimized ? '60px' : 'auto',
      overflow: 'hidden',
      position: 'fixed',
      bottom: minimized ? 16 : 'auto',
      right: minimized ? 16 : 'auto',
      margin: minimized ? 0 : 'auto',
      width: minimized ? '600px' : '100%',
      maxWidth: minimized ? '600px' : 'md'
    }
  }}

>
  {/* Header */}
<DialogTitle sx={{
  backgroundColor: '#219C90',
  color: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  padding: '10px 16px'
}}>
<Typography fontWeight="bold"
    sx={{
      fontSize: '14px',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      maxWidth: '75%'
    }}
>
  Salary Details 
  {detailsData[0]?.process ? ` — ${detailsData[0].process}` : ''} 
  {' | '}
  {moment(fromDate).format('DD-MM-YYYY')} 
  {' → '} 
  {moment(toDate).format('DD-MM-YYYY')}
</Typography>

<Box
  sx={{
    position: 'absolute',
    right: 8,
    top: 4,
    display: 'flex',
    gap: 1,
    borderRadius: '20px',
    padding: '2px 6px'
  }}
>
  {/* Minimize */}
  <IconButton
    onClick={() => setMinimized(!minimized)}
    size="small"
    sx={{
      color: 'white',
      '&:hover': {
        backgroundColor: 'rgba(255,255,255,0.25)'
      }
    }}
  >
    <RemoveIcon fontSize="small" />
  </IconButton>

  {/* Close */}
  <IconButton
    onClick={() => setOpen(false)}
    size="small"
    sx={{
      color: 'white',
      '&:hover': {
        backgroundColor: '#e53935'  
      }
    }}
  >
    <CloseIcon fontSize="small" />
  </IconButton>
</Box>
</DialogTitle>

  {/* Content */}
  {!minimized && (
  <DialogContent sx={{ p: 1, backgroundColor: '#f5f5f5' }}>
    
    {/* Scroll area */}
  <Box sx={{ maxHeight: '60vh', overflowY: 'auto' }}>

  {Object.keys(groupedData).length > 0 ? (
<>
    {Object.entries(groupedData).map(([date, items], idx) => {

      const total = items.reduce(
        (sum, i) => sum + Number(i.perDaySalary),
        0
      );

      return (
        <Box key={idx} sx={{ mb: 3 }}>

          {/* DATE HEADER */}
          <Typography
            sx={{
              fontWeight: 'normal',
              fontSize: '14px',
              mb: 1,
              color: '#1976d2'
            }}
          >
            Date : {date}
          </Typography>

          {/* TABLE */}
          <Box
            sx={{
              borderRadius: 2,
              overflow: 'hidden',
              boxShadow: 2
            }}
          >
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px' }}>

  <thead style={{ backgroundColor: '#e3f2fd' }}>
    <tr>
      <th style={{ padding: '4px 8px', textAlign: 'left' }}>S.No</th>
      <th style={{ padding: '4px 8px', textAlign: 'left' }}>Employee Name</th>
      <th style={{ padding: '4px 8px', textAlign: 'left' }}>Designation</th>
      <th style={{ padding: '4px 8px', textAlign: 'right' }}>Salary</th>
      <th style={{ padding: '4px 8px', textAlign: 'right' }}>Per Day</th>
    </tr>
  </thead>

  <tbody>
    {items.map((emp, i) => (
      <tr key={i} style={{
        backgroundColor: i % 2 === 0 ? '#fff' : '#f9f9f9'
      }}>
        <td style={{ padding: '4px 8px' }}>{i+1}</td>
        <td style={{ padding: '4px 8px' }}>{`${emp.employeeCode} - ${emp.employeeName}`}</td>
        <td style={{ padding: '4px 8px' }}>{emp.designation}</td>
       <td style={{ padding: '6px 8px', textAlign: 'right' }}>
  {Number(emp.salary).toLocaleString('en-IN')}
</td>

<td style={{ padding: '6px 8px', textAlign: 'right' }}>
  {Number(emp.perDaySalary).toLocaleString('en-IN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })}
</td>

      </tr>
    ))}

<tr style={{ fontWeight: 'bold' }}>
  <td
    colSpan={4}
    style={{ padding: '4px 8px', backgroundColor: '#d0d0d0' }}
  >
    Total
  </td>

  <td
    style={{
      padding: '4px 8px',
      textAlign: 'right',
      backgroundColor: '#d0d0d0'
    }}
  >
    {Number(total).toLocaleString('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })}
  </td>
</tr>

  </tbody>
</table>
          </Box>
        </Box>
      );
    })}
    <Box
        sx={{
          padding: '10px ',
          backgroundColor: '#219C90',
          borderRadius: 2,
          display: 'flex',
          justifyContent: 'space-between',
          color: 'white'
        }}
      >
        <Typography fontWeight="bold">
          Grand Total
        </Typography>

      <Typography fontWeight="bold">
   {Number(grandTotal).toLocaleString('en-IN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })}
</Typography>
      </Box>
 </>
  ) : (
    <Typography align="center" mt={2}>
      No Data Found
    </Typography>
  )}

</Box>
  </DialogContent> )}
</Dialog>
    </>
  );
};

export default ProcessTrackerReport;
